import { gif, loader, showMessage, showMessageBox, toast } from "../../components/message"
import { estabelecimento } from "../../Estabelecimento/estabelecimento"
import { usuario } from "../../usuario"
import { buttonLoader, createElement, criaInstanciaGeocoder, formatAddress, formatAddressGeocode, getUrlAction, inputIsValid, isEmpty, loginMessage, newPage, parent, random, ripple, sentryError } from "../../utils"
import buscaCep, { cep } from 'cep-promise'
import { selecionaEndereco } from "../../mobile"
import * as Sentry from '@sentry/browser'

export const enderecos = fromConfirmOrder => {
    if (usuario.logado) {

        newPage({
            id: 'pagina-enderecos',
            appbarTitle: 'Endereços',
            body: `
            <div id="enderecos">
                <div class="enderecos-container">
                    <div class="cards">
                        ${gif.start('', 'gif-container')}
                    </div>
                    <button id="btn-novo-endereco" class="btn btn-primary btn-fixed">Adicionar endereço</button>
                </div>
            </div>`,

            callback: () => {
                select('#btn-novo-endereco').addEventListener('click', () => {
                    try {
                        console.log('busca localizacao')
                        if (!estabelecimento.chaveAPIGoogleMaps) {
                            novoEndereco()
                            console.error('Chave da API do Google Maps não configurada, será possível cadastrar endereços, mas não será possível buscar a localização atual do usuário.')
                        } else {
                            buscaLocalizacaoUsuario()
                        }
                    } catch (e) {
                        Sentry.captureException(e)
                        console.error(e)
                        novoEndereco()
                    }

                })

                const cardContainer = select('#pagina-enderecos .page-body .cards')
                cardContainer.innerHTML = ''
                cardContainer.style.height = '100%'

                if (usuario.enderecos && Array.isArray(usuario.enderecos) && usuario.enderecos.length > 0) {

                    usuario.enderecos.forEach((address) => {
                        const isTheMainAddress = address.Principal || usuario.enderecos.length == 1 ? "color='yellow'" : ''

                        if (address.StrCidade.length == 1 || address.StrCidade.length == 0) {
                            address.StrCidade = estabelecimento.endereco.cidade;
                        }

                        isTheMainAddress && (usuario.enderecoPrincipal = address)

                        const addressString =
                            [
                                address.Rua,
                                address.Numero,
                                address.complemento,
                                address.complemento,
                                address.StrBairro
                            ]
                                .filter((string) => string != '' && string != undefined)
                                .join(', ') + '.'

                        cardContainer.innerHTML += `
                        <div id="endereco-${address.Id}" class="card favorite" data-id="${address.Id} ">
                        <header>
                            <span>${address.Apelido || ""}</span>
                            <span class="star" ${isTheMainAddress}></span>
                        </header>
                        <div class="body">
                            <div>${addressString}</div>
                            <div>${address.StrCidade}</div>
                            <div>${address.Telefone}</div>
                        </div>
                        ${fromConfirmOrder
                                ? `<div class="footer btn-selecionar-endereco" data-address-id="${address.Id}"><span>Selecionar</span></div>`
                                : `<div class="footer btn-editar-endereco" data-address-id="${address.Id}"><span>Editar</span></div>`
                            }
                        </div>`})

                    if (usuario.enderecos.length == 1) {
                        [usuario.enderecoPrincipal] = usuario.enderecos
                        setTimeout(function () {
                            $.ajax({
                                url: getUrlAction('Cadastros', 'SetEnderecoPrincipal'),
                                type: 'POST',
                                data: {
                                    id: JSON.stringify(usuario.enderecoPrincipal.Id)
                                },
                                async: true,
                                success: function (response) { },
                                error: function (response) { }
                            })
                        }, 100)
                    }

                    if (fromConfirmOrder) {

                        selectAll('.btn-selecionar-endereco').forEach(elementoEndereco => {
                            elementoEndereco.addEventListener('click', () => {
                                const idEndereco = elementoEndereco.getAttribute('data-address-id')
                                selecionaEndereco(idEndereco)
                            })
                        })

                    } else {
                        selectAll('.btn-editar-endereco').forEach(elementoEditar => {
                            elementoEditar.addEventListener('click', () => {
                                const idEndereco = elementoEditar.getAttribute('data-address-id')
                                editarEndereco(idEndereco)
                            })
                        })
                    }
                } else {
                    const bodyAddresses = select('#pagina-enderecos .page-body')
                    bodyAddresses.querySelector('#enderecos').classList.add('u-center')
                    bodyAddresses.querySelector('.cards').innerHTML =
                        "<div class='u-center'><span class='text-empty'>Ainda não há endereços cadastrados</span></div>"
                }

                selectAll('.star').forEach((star) => {
                    star.addEventListener('click', ({ target }) => {
                        mixpanel.track("Alterou o endereço principal", { "Estabelecimento": estabelecimento.fantasia });
                        const idEnd = Number(parent(target, 2).getAttribute('data-id'))
                        const auxContainer = select('#aux-container')
                        const page = select('#aux-page')

                        gif.fullScreen(document.body, 'Salvando endereço principal')
                        page.style.filter = 'blur(3px)'
                        setTimeout(function () {
                            $.ajax({
                                url: getUrlAction('Cadastros', 'SetEnderecoPrincipal'),
                                type: 'POST',
                                data: {
                                    id: JSON.stringify(idEnd)
                                },
                                async: true,
                                success: function (response) {

                                    usuario.enderecoPrincipal = JSON.parse(response)
                                    selectAll('.star').forEach((star) =>
                                        star.setAttribute('color', 'unset')
                                    )
                                    target.setAttribute('color', 'yellow')

                                    setTimeout(() => {
                                        page.style.filter = 'blur(0)'
                                        gif.end(auxContainer)

                                        showMessage(
                                            'Salvo',
                                            'Endereço principal definido.',
                                            'success',
                                            'OK',
                                            () => {
                                                let buttonMsg = select('.message-box button')
                                                if (buttonMsg) {
                                                    buttonMsg.addEventListener('click', () => {
                                                        select('.message-box').remove()
                                                    })
                                                }
                                            }
                                        )
                                    }, 200)
                                },
                                error: function (response) { }
                            })
                        }, 100)
                    })
                })

            }
        })
    } else {
        loginMessage()
    }
}

function templateEndereco(obj) {
    let [
        id,
        cep,
        estado,
        bairro,
        cidade,
        rua,
        numero,
        complemento,
        referencia,
        telefone,
        apelido
    ] = ['', '', '', '', '', '', '', '', '', '', '']

    if (obj.response) {
        id = obj.response.Id
        cep = obj.response.CEP
        estado = obj.response.UFCidade.Sigla || obj.response.StrEstado
        bairro = obj.response.StrBairro
        cidade = obj.response.StrCidade
        rua = obj.response.Rua
        numero = obj.response.Numero
        complemento = obj.response.Complemento
        referencia = obj.response.Referencia
        telefone = obj.response.Telefone
        apelido = obj.response.Apelido
    }

    let optionsBairro = ''
    estabelecimento.entrega.bairros.forEach((enderecoMogoSmart) => {
        optionsBairro += `<option value="${enderecoMogoSmart.Id}" > ${enderecoMogoSmart.Descricao}</option> `
    })


    let optionsCity = ""
    let cidadeSelecionada = {
        id: 0,
        Descricao: ''
    }
    estabelecimento.entrega.cidades.forEach(cidade => {
        optionsCity += `<option value="${cidade.Id}" > ${cidade.Nome}</option> `
        if (obj && obj.response && obj.response.StrCidade && cidade.Nome == obj.response.StrCidade) {
            cidadeSelecionada.id = cidade.Id
            cidadeSelecionada.Descricao = cidade.Nome
        }
    })

    if (!cidadeSelecionada.Descricao) {
        cidadeSelecionada.Descricao = "Cidade"
    }

    let bairroTemplate = ''
    if (optionsBairro) {
        bairroTemplate = `
        <div class="select-container">
            <i class="fas fa-chevron-down"></i>
            <select class="primary-select">
                <option value="0">Bairro</option>
                    ${optionsBairro}
            </select> 
        </div>
         `
    } else {
        bairroTemplate = `<input id="end-bairro" class="input" type="text" placeholder="Bairro" value="${bairro ? bairro : ''} ">`
    }

    const trashTemplate = `
        <div class="trash">
            <img src="/images/mobile/trash.svg" />
            <span>Excluir endereço</span>
        </div>`

    const estados = ['AM', 'AC', 'AL', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SE', 'SP', 'TO']

    let html = `
        <div id="novo-endereco" class="${obj.type == 'edit' ? 'editar-endereco' : ''}">
            <div class="endereco-container">
                <div class="pin">
                    <img src="/images/mobile/pin.svg">
                </div>
                <div class="search">                    
                    <input id="cep-input" class="primary-input" placeholder="CEP" required  name="cep" value="${cep ? cep : ''}">
                    <button id="btn-dados-cep">
                        <img src="/images/mobile/search.svg">
                        <div class="showbox">
                            <div class="loader"> <svg class="circular" viewBox="25 25 50 50">
                                <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
                            </svg></div>
                        </div>
                    </button>
                </div>
                <div class="endereco-inputs">

                    <div class="u-flex-between"> 
                        <div class="input-wrapper">
                            <input type="text" id="end-rua" value="${rua ? rua : ''}" name="rua" required>
                            <label for="end-rua">Rua</label>
                        </div> 
                        
                        <div class="input-wrapper">
                            <input type="number" id="end-numero" value="${numero ? numero : ''}" name="numero" required>
                            <label for="end-numero">Nº</label>
                        </div> 
                    </div>

                    ${bairroTemplate}

                    <div class="u-flex-between">

                        <div class="input-wrapper">
                            <div class="select-container">
                                <i class="fas fa-chevron-down"></i>
                                <select id="combo-cidade" class="primary-select">
                                    <option value="${cidadeSelecionada.id}">${cidadeSelecionada.Descricao}</option>
                                        ${optionsCity}
                                </select> 
                            </div>
                        </div> 

                        
                        <div class="input-wrapper">
                            <div class="select-container">
                                <i class="fas fa-chevron-down"></i>           
                                <SELECT id="end-estado" class="primary-select">
                                    <option value="estado">Estado</option>
                                    ${estados.map(estado => `<option value="${estado}">${estado}</option>`).join('')}
                                </SELECT>
                            </div>
                        </div> 

                    </div>

                    <div class="input-wrapper">
                        <input type="text" id="end-complemento" value="${complemento ? complemento : ''}" name="complemento" required>
                        <label for="end-complemento">Complemento (opcional)</label>
                    </div> 

                    <div class="input-wrapper">
                        <input type="text" id="end-referencia" value="${referencia ? referencia : ''}" name="referencia" required>
                        <label for="end-referencia">Refêrencia (opcional)</label>
                    </div> 

                    <div class="u-flex-between"> 
                        <div class="input-wrapper">
                            <input type="text" id="end-telefone" value="${telefone ? telefone : ''}" name="telefone" required>
                            <label for="end-telefone">Telefone</label>
                        </div> 
                        
                        <div class="input-wrapper">
                            <input type="text" id="end-apelido" value="${apelido ? apelido : ''}" name="apelido" maxlength="40" required>
                            <label for="end-apelido">Apelido (opcional)</label>
                        </div>
                    </div>

                </div>
                ${obj.type == 'edit' ? trashTemplate : ''}
                <button id="salva-novo-end" class="btn btn-primary" id-obj-en=${id != '' ? id : 0
        }>${obj.type == 'new' ? 'Cadastrar endereço' : 'Salvar'
        }</button>
            </div>
        </div>`
    return html;
}

function getDadosCep(currentTarget) {
    if (!currentTarget.classList.contains('searching')) {

        selectAll('.select-endereco').forEach((element) => {
            element.remove()
        })

        const endBairro = select('#end-bairro')
        if (endBairro) {
            endBairro.style.display = ''
        }

        const cepVal = select('#cep-input').value
        buscaCep(cepVal, { providers: ['brasilapi', 'viacep', 'widenet'] })
            .then(data => {

                select('#end-estado').value = data.state
                // select('#end-cidade').value = data.city
                select('#combo-cidade').options[0].innerHTML = data.city
                select('#end-rua').value = data.street

                const selectElement = select('.select-container .primary-select')

                if (selectElement) {
                    if (estabelecimento.entrega.bairros.length > 0) {
                        if (data && data.neighborhood) {
                            typeof currentTarget != "undefined" && currentTarget.classList.remove('searching')
                            Array
                                .from(selectElement.options)
                                .forEach(option => {
                                    if (option.text && option.text.toLowerCase().trim() == data.neighborhood.toLowerCase().trim()) {
                                        selectElement.value = option.value
                                    }
                                })
                        }
                    } else {
                        sentryError(estabelecimento.fantasia + 'Bairros não foram cadastrados')
                        typeof currentTarget != "undefined" && currentTarget.classList.remove('searching')
                    }
                }

            }).catch(() => {
                typeof currentTarget != "undefined" && currentTarget.classList.remove('searching')
                alert('Cep não encontrado')
            })
    }
}

export function editarEndereco(idEnd) {
    mixpanel.track("Editar endereço", { "Estabelecimento": estabelecimento.fantasia });
    getLocalEntrega(idEnd, (response) => {
        const objEndereco = [];
        objEndereco.bairro = response.StrBairro ?? '';
        objEndereco.cep = response.CEP ?? '';
        objEndereco.cidade = response.StrCidade ?? '';
        objEndereco.enderecoFormatado = formatAddress(response) ?? '';
        objEndereco.estado = response.StrEstado ?? '';
        objEndereco.numero = response.Numero ?? '';
        objEndereco.rua = response.Rua ?? '';
        objEndereco.complemento = response.Complemento ?? '';
        objEndereco.referencia = response.Referencia ?? '';
        objEndereco.telefone = response.Telefone ?? '';
        objEndereco.apelido = response.Apelido ?? '';

        novoEndereco(objEndereco, idEnd);
    })
}

function getLocalEntrega(idEndereco, callback) {

    var cUrl = getUrlAction('Cadastros', 'GetLocalEntrega')
    $.ajax({
        type: 'GET',
        url: cUrl,
        data: {
            id: typeof idEndereco == "string" ? Number(idEndereco) : idEndereco
        },
        success: function (response, status, xhr) {
            return callback(JSON.parse(response))
        },
        error: function () {
            alert('Não foi possível conectar ao servidor, verifique a conexão com a rede, e tente novamente!');

            $('.message-box__button.error').on('click', () => {
                select('.message-box').remove()
            })
        }
    })
}

function salvaEndereco(Id, el, idPagina) {
    //identifica se já foi clicado no botão
    let submit = el.getAttribute('data-submit')
    submit && (submit = Number(submit))

    //Se não foi clicado
    if (!submit) {
        const alertMessage = (message) => {
            showMessageBox({
                id: 'alert-message',
                icon: 'warning',
                message: `Selecione ${message} antes de continuar.`,
                classList: 'no-icon-background small',
                default: true
            })
        }

        let bairro = ''
        bairro = select('.endereco-container .primary-select')

        const cep = select('#cep-input').value
        const rua = select('#end-rua').value
        const telefone = select('#end-telefone').value
        const strEstado = select('#end-estado').value
        const numero = Number(select('#end-numero').value)
        const complemento = select('#end-complemento').value
        const referencia = select('#end-referencia').value
        const apelido = select('#end-apelido').value
        let idBairro = 0


        let strCidade = ''
        const comboCidade = select('#combo-cidade')
        if (comboCidade) {
            if (comboCidade.selectedOptions && comboCidade.selectedOptions[0]) {
                strCidade = comboCidade.selectedOptions[0].textContent
                if (strCidade === 'Cidade') {
                    strCidade = ''
                }
            } else {
                return false
            }
        } else {
            Sentry.captureException(new Error('Combo cidade não encontrado'))
        }


        if (bairro && bairro.nodeName && bairro.nodeName === 'SELECT') {
            idBairro = bairro.value ? Number(bairro.value) : 0
        }


        if (
            inputIsValid(select('#end-estado'), 'Preencha este campo') &&
            inputIsValid(select('#end-rua'), 'Preencha este campo') &&
            inputIsValid(select('#end-numero'), 'Preencha este campo') &&
            inputIsValid(select('#end-telefone'), 'Preencha este campo')
        ) {
            if (strEstado == "Estado") {
                select('#end-estado').setCustomValidity('Selecione uma Estado')
                select('#end-estado').reportValidity()
                return
            }

            if (
                bairro && bairro.nodeName && bairro.nodeName === 'SELECT'
                    ? bairro.value && bairro.value != '0'
                        ? true
                        : alertMessage('um bairro')
                    : true
            ) {

                if (strCidade == 'Cidade') {
                    alertMessage('uma cidade')
                    return
                }

                el.innerHTML = loader()
                el.setAttribute('data-submit', 1)

                const endereco = {
                    Id,
                    strEstado,
                    strCidade,
                    rua,
                    numero,
                    complemento,
                    referencia,
                    telefone,
                    apelido,
                    idBairro,
                    cep
                }

                setTimeout(function () {
                    var cUrl = getUrlAction('Cadastros', 'SaveLocalEntrega')
                    $.ajax({
                        type: 'POST',
                        url: cUrl,
                        data: {
                            str: JSON.stringify(endereco)
                        },
                        success: function (response) {
                            response = JSON.parse(response)

                            if (response.lValid) {
                                const callback = () => {
                                    const [enderecoEditado] = usuario.enderecos.filter(item => item.Id == response.endereco.Id)
                                    if (enderecoEditado) {
                                        const index = usuario.enderecos.indexOf(enderecoEditado)
                                        usuario.enderecos.splice(index, 1)
                                    }

                                    usuario.enderecos.push(response.endereco)
                                    $('#novo-endereco .app-bar img').click()

                                    if (!usuario.enderecoPrincipal) {
                                        usuario.enderecoPrincipal = response.endereco
                                    }

                                    $('.message-box button').on('click', () => {
                                        $('.message-box').remove()
                                        $(idPagina).remove()
                                        $('#pagina-enderecos .app-bar img').click()
                                        enderecos()

                                        const edicao = select('#editar-endereco')
                                        edicao && edicao.remove()
                                    })
                                }
                                showMessage(
                                    '',
                                    'Endereço salvo com sucesso',
                                    'success',
                                    'OK',
                                    callback,
                                    true,
                                    'small'
                                )
                            } else {
                                if (
                                    typeof response.erros == 'object' &&
                                    response.erros.length > 1
                                ) {
                                    let errorTemplate = ''
                                    response.erros.forEach(
                                        (erro) => (errorTemplate += `<div>${erro}</div>`)
                                    )
                                    response.erros = errorTemplate
                                }
                                showMessageBox({
                                    id: 'message-error',
                                    icon: 'warning',
                                    message: response.erros,
                                    classList: 'no-icon-background small',
                                    default: true,
                                    callback: () => {
                                        el.innerHTML = 'Cadastrar endereço'
                                        el.setAttribute('data-submit', 0)
                                    }
                                })
                            }
                        },
                        error: function () {
                            showMessage(
                                '',
                                'Não foi possível conectar ao servidor, verifique a conexão com a rede, e tente novamente!',
                                'error',
                                'OK',
                                '',
                                true,
                                'small'
                            )
                        }
                    })
                }, 100)

                if (!usuario.telefone) {
                    axios
                        .get(getUrlAction('Cadastros', 'SetUserPhone'), {
                            params: {
                                telefone
                            }
                        })
                        .then(function ({ data }) {
                            if (data.sucesso) {
                                usuario.telefone = telefone
                            }
                        })
                        .catch(function (error) {
                            sentryError.exception(error)
                        })
                }

            }
        } else {
            toast('Preencha todos os campos antes de continuar')
        }
    }
}

export const buscaBairrosMogoSmart = (callback) => {
    if (usuario.logado) {
        $.ajax({
            type: 'GET',
            url: getUrlAction('Cadastros', 'GetEnderecosSmart'),
            success: function (response) {

                try {
                    const { bairros, cidades } = JSON.parse(response)

                    if (cidades) {
                        estabelecimento.entrega.cidades = cidades.filter(cidade => cidade.Nome)

                        if (cidades.length == 0) {
                            Sentry.captureException(new Error(estabelecimento.fantasia + " - Nenhuma cidade cadastrada"));
                        }
                    }

                    if (Array.isArray(bairros)) {
                        estabelecimento.entrega.bairros = bairros
                        estabelecimento.entrega.TemPedidoMinimoPorBairro = bairros.some(bairro => bairro.PedidoMinimo?.parseNumber() > 0)

                        if (estabelecimento.entrega.bairros.length > 0) {

                            estabelecimento.entrega.bairros.forEach(bairro => {
                                bairro.Descricao = bairro.Descricao
                                    .toLocaleLowerCase()
                                    .split(' ')
                                    .map(string => string = string.capitalizeFirstLetter())
                                    .join(' ')
                            })

                            //Filtra o array para remover os itens que não serão exibidos
                            estabelecimento.entrega.bairros = estabelecimento.entrega.bairros.filter(
                                (endereco) => endereco.ExibirDelivery
                            )

                            estabelecimento.entrega.bairros = estabelecimento.entrega.bairros.sort((a, b) =>
                                a.Descricao.localeCompare(b.Descricao)
                            )
                        }
                    } else {
                        sentryError.exception('[GetEnderecosSmart] - A resposta não é um Array')
                    }

                } catch (error) {
                    console.error(error)
                    Sentry.captureException(error)
                }

                callback && callback()

            },
            error: (error) => {
                Sentry.captureException(error)
                typeof currentTarget != "undefined" && currentTarget.classList.remove('searching')
            }
        })
    }
}

export function solicitaEndereco(entrega) {

    const msg = 'Para continuar, você precisa informar um endereço de entrega'
    const wrapper = createElement('div', { class: "wrapper-solicita-endereco" })
    wrapper.innerHTML = `
    <div class="wrapper-content">
        <img src="images/endereco.svg" alt="Mulher ao lado de celular exibindo um mapa">
        <div>
            ${entrega == false ? 'O endereço cadastrado não está no raio de entrega do estabelecimento.' : msg}
        </div>
    </div>
    `

    const content = select('.wrapper-content', wrapper)

    const buttonWrapper = createElement('div', { class: "flex-column gap-8" })
    content.appendChild(buttonWrapper)

    const buttonContinuar = createElement('button', { class: "btn-azul" }, `${entrega == false ? 'Cadastrar novo endereço' : 'Cadastrar endereço'}`)
    buttonContinuar.addEventListener('click', () => {
        wrapper.remove()

        cadastrarNovoEndereco()


    })

    const buttonCancelar = createElement('button', { class: "btn-transparent" }, 'Vou retirar no local')
    buttonCancelar.addEventListener('click', () => {

        const buttonBuscarNoLocal = select('[for="inp-buscar"]')
        buttonBuscarNoLocal && buttonBuscarNoLocal.click()

        wrapper.remove()

        const confirmarItens = select('#confirmarPedido')
        confirmarItens && confirmarItens.click()

    })

    buttonWrapper.appendChild(buttonContinuar)

    if (!estabelecimento.desabilitarEntregaBalcao) {
        buttonWrapper.appendChild(buttonCancelar)
    }

    document.body.appendChild(wrapper)
}

export const novoEndereco = (objEndereco, idEnd, obrigatorioCEP = false) => {
    const wrapper = createElement('div', { class: "wrapper-solicita-endereco" })
    const content = createElement('div', { class: "wrapper-content" })
    wrapper.appendChild(content)

    //ìndice da cidade do estabelecimento
    let idCidade = 0
    let cidade
    if (objEndereco) {
        cidade = estabelecimento.entrega.cidades.find(cidade => cidade.Nome == objEndereco.cidade)
    }
    if (cidade) {
        idCidade = cidade.Id
    }

    let indexEstado = 0
    const estados = ["AM", "AC", "AL", "AP", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO"]
    indexEstado = estados.findIndex(estado => estado == estabelecimento.endereco.estado)

    if (usuario && !usuario.telefone || usuario.telefone.length < 8) {
        usuario.telefone = ""
    }

    content.innerHTML = `
    
    <div class="font-color-primary font-14 font-weight-500">Onde o pedido será entregue?</div>
    
    <div class="w-100 flex-column gap-8">
        
        <div class="u-relative w-100">
            <div class="input-wrapper u-relative">
                <input type="text" id="cep" name="cep" required="true">
                <label for="cep">Pesquisar pelo CEP</label>
            </div>

            <button class="search-button btn-azul">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5 7.00002C11.5 7.59096 11.3836 8.17613 11.1574 8.72209C10.9313 9.26806 10.5998 9.76413 10.182 10.182C9.7641 10.5998 9.26803 10.9313 8.72206 11.1575C8.1761 11.3836 7.59094 11.5 6.99999 11.5C6.40904 11.5 5.82388 11.3836 5.27791 11.1575C4.73195 10.9313 4.23587 10.5998 3.81801 10.182C3.40014 9.76413 3.06868 9.26806 2.84253 8.72209C2.61638 8.17613 2.49999 7.59096 2.49999 7.00002C2.49999 5.80654 2.97409 4.66195 3.81801 3.81804C4.66192 2.97412 5.80651 2.50002 6.99999 2.50002C8.19346 2.50002 9.33805 2.97412 10.182 3.81804C11.0259 4.66195 11.5 5.80654 11.5 7.00002ZM10.68 11.74C9.47437 12.676 7.95736 13.1173 6.43779 12.9741C4.91822 12.831 3.51033 12.1141 2.50074 10.9694C1.49114 9.82473 0.955743 8.33831 1.00352 6.81277C1.05131 5.28722 1.67869 3.83722 2.75794 2.75797C3.8372 1.67872 5.28719 1.05134 6.81274 1.00355C8.33829 0.955771 9.8247 1.49117 10.9694 2.50077C12.1141 3.51036 12.831 4.91825 12.9741 6.43782C13.1173 7.95738 12.676 9.47439 11.74 10.68L14.78 13.72C14.8537 13.7887 14.9128 13.8715 14.9538 13.9635C14.9948 14.0555 15.0168 14.1548 15.0186 14.2555C15.0204 14.3562 15.0018 14.4562 14.9641 14.5496C14.9264 14.643 14.8702 14.7278 14.799 14.799C14.7278 14.8703 14.643 14.9264 14.5496 14.9641C14.4562 15.0018 14.3562 15.0204 14.2555 15.0186C14.1548 15.0168 14.0554 14.9948 13.9635 14.9538C13.8715 14.9128 13.7887 14.8537 13.72 14.78L10.68 11.74Z" fill="#fff"/>
                </svg>
            </button>

        </div>    

        <div id="cep-erro-area"></div>

        <div class="flex-column gap-8 u-m-t-8">
            <div class="flex gap-8" style="justify-content: flex-end; gap: 4px;">
                <input type="checkbox" id="sem-numero" name="sem-numero">
                <label for="sem-numero" style="color: #47494c; font-size: 13px; font-weight: 500;">Endereço sem número (S/N)</label>
            </div>
            <div class="flex gap-8">
                <div class="input-wrapper">
                    <input type="text" id="logradouro" name="logradouro" required="true">
                    <label for="rua">Rua</label>
                </div>

                <div class="input-wrapper numero">
                    <input type="text" id="numero" name="numero" required="true">
                    <label for="numero">Número</label> 
                </div>
            </div>
        </div>

        <div class="input-wrapper">
            <select  id="bairro" name="bairro" required="true" class="inative"/>
                <option value="0">Selecione um bairro</option>
                ${estabelecimento.entrega.bairros.map(bairro => { return `<option value="${bairro.Id}">${bairro.Descricao}</option>` }).join('')}
            </select>
        </div>
            
        <div class="flex gap-8">
            <div class="input-wrapper">
                <select  id="cidade" name="cidade" required="true" class="${idCidade === 0 ? 'inative' : ''}" value=${idCidade}>
                <option value="0">Selecione uma cidade</option>
                    ${estabelecimento.entrega.cidades.map(cidade => { if (cidade) { return `<option value="${cidade.Id}">${cidade.Nome}</option>` } }).join('')}
                </select>
            </div>

            <div class="input-wrapper estado">
                <select  id="estado" name="estado" required="true" class="${indexEstado >= 0 ? 'inative' : ''}" value="${indexEstado}">
                    <option value="0">Selecione um estado</option>
                    ${estados.map((estado, index) => { return `<option value="${index}">${estado}</option>` }).join('')}
                </select>
            </div>
        </div>

        <div class="input-wrapper">
            <input type="text" id="telefone" name="telefone" required="true" value="${usuario.telefone}"/>
            <label for="estado">Telefone</label>
        </div>

        <div class="flex align-center justfy-center gap-8 font-weight-500 font-12 text-blue u-p-8-0 switch-opicionais">
            <div>Complemento, Referência e apelido</div>           
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7803 6.21967C13.0732 6.51256 13.0732 6.98744 12.7803 7.28033L8.53033 11.5303C8.23744 11.8232 7.76256 11.8232 7.46967 11.5303L3.21967 7.28033C2.92678 6.98744 2.92678 6.51256 3.21967 6.21967C3.51256 5.92678 3.98744 5.92678 4.28033 6.21967L8 9.93934L11.7197 6.21967C12.0126 5.92678 12.4874 5.92678 12.7803 6.21967Z" fill="currentColor"/>
            </svg>
        </div>
        <div class="flex-column gap-8 oculto">
            <div class="input-wrapper">
                <input type="text" id="complemento" name="complemento"/>
                <label for="estado">Complemento</label>
            </div>
            
            <div class="input-wrapper">
                <input type="text" id="referencia" name="referencia"/>
                <label for="estado">Referêcia</label>
            </div>
            
            <div class="input-wrapper">
                <input type="text" id="apelido" name="apelido" maxlength="40" />
                <label for="estado">Apelido</label>
            </div>
        </div>

        <div id="error-area"></div>
        <div class="flex gap-8 u-m-t-8">
            <button id="cancelar" class="btn-transparent">Cancelar</button>
            <button id="continuar" class="btn-azul">Continuar</button>
        </div>
    </div>
    `

    const logradouroInput = select('#logradouro', content)
    const numeroInput = select('#numero', content)
    const bairroInput = select('#bairro', content)
    const cidadeInput = select('#cidade', content)
    const estadoInput = select('#estado', content)
    const telefoneInput = select('#telefone', content)
    const apelidoInput = select('#apelido', content)
    const referenciaInput = select('#referencia', content)
    const complementoInput = select('#complemento', content)
    const cepSearchButton = select('.search-button', content)
    const cepInput = select('#cep', content)
    const semNumeroInput = select('#sem-numero', content)

    if (objEndereco) {
        logradouroInput.value = objEndereco.rua
        numeroInput.value = objEndereco.numero

        try {
            if (objEndereco.bairro && bairroInput.options) {
                const opcao = selecionaBairroEquivalente(objEndereco.bairro, Array.from(bairroInput.options))
                if (opcao) {
                    if (!opcao.Cidade || opcao.Cidade.Id == idCidade) {
                        bairroInput.value = opcao.value
                    }
                }
            }
        } catch (e) {
            console.log(e)
            Sentry.captureException(e)
        }



        cidadeInput.value = objEndereco.cidade
        estadoInput.value = objEndereco.estado
        telefoneInput.value = objEndereco.telefone || usuario.telefone
        apelidoInput.value = objEndereco.apelido || ''
        referenciaInput.value = objEndereco.referencia || ''
        complementoInput.value = objEndereco.complemento || ''
        cepInput.value = objEndereco.cep || ''

    }

    cidadeInput.value = idCidade
    estadoInput.value = indexEstado

    semNumeroInput.onchange = () => {
        if (semNumeroInput.checked) {
            numeroInput.value = 'SN'
        } else {
            numeroInput.value = ''
        }
    }

    bairroInput.onchange = () => {
        bairroInput.setCustomValidity('')
        //verifica se o bairro pertence a cidade selecionada
        const idBairro = Number(bairroInput.value)
        const bairro = estabelecimento.entrega.bairros.find(bairro => bairro.Id == idBairro)
        const idCidade = Number(cidadeInput.value)
        if (bairro && bairro.Cidade) {
            const pertence = bairro?.Cidade?.Id == idCidade
            if (!pertence) {
                bairroInput.setCustomValidity('Selecione um bairro que pertence a cidade selecionada')
                bairroInput.reportValidity()
                bairroInput.classList.add('inative')
                bairroInput.value = 0
                return
            }
        }

        bairroInput.classList.remove('inative')
    }

    cidadeInput.onchange = () => {
        cidadeInput.classList.remove('inative')
    }
    estadoInput.onchange = () => {
        estadoInput.classList.remove('inative')
    }

    //se alterar um valor do cep
    cepInput.addEventListener('keyup', () => {
        cepInput.setCustomValidity('')
        const value = cepInput.value.replace(/\D/g, '')
        if (value.length === 8) {
            cepSearchButton.click()
        }
    })

    IMask(cepInput, {
        mask: '00000-000',
        max: 10
    })

    IMask(telefoneInput, {
        mask: '(00) 00000-0000',
    })

    const buttonOpcionais = select('.switch-opicionais', content)
    const opcionais = select('.oculto', content)
    buttonOpcionais.addEventListener('click', () => {
        buttonOpcionais.querySelector('svg').classList.toggle('rotate-arrow')
        opcionais.classList.toggle('oculto')
    })

    cepSearchButton.addEventListener('click', () => {

        const cepErrorArea = select("#cep-erro-area", content)
        cepErrorArea.innerHTML = ""
        if (inputIsValid(cepInput)) {
            const searchIcon = cepSearchButton.innerHTML
            cepSearchButton.innerHTML = loader()
            //deixa apenas os números
            const cep = cepInput.value.replace(/\D/g, '')
            buscaCep(cep, { providers: ['brasilapi', 'viacep', 'widenet'] })
                .then(response => {

                    cepSearchButton.innerHTML = searchIcon

                    if (response) {

                        logradouroInput.value = response.street

                        if (response.city) {
                            Array.from(cidadeInput.options)
                                .forEach(option => {

                                    //remove todos os espaços e acentos
                                    const cidade = option.textContent.normalize('NFD').replace(/[\u0300-\u036f]/g, "")
                                    const cidadeResponse = response.city.normalize('NFD').replace(/[\u0300-\u036f]/g, "")

                                    if (cidade.toLowerCase() === cidadeResponse.toLowerCase()) {
                                        cidadeInput.value = option.value
                                    }
                                })
                        }

                        if (response.state) {
                            Array.from(estadoInput.options)
                                .forEach(option => {
                                    if (option.textContent.toLowerCase() === response.state.toLowerCase()) {
                                        estadoInput.value = option.value
                                    }
                                })
                        }

                        if (response.neighborhood) {
                            Array.from(bairroInput.options)
                                .forEach(option => {
                                    if (option.textContent && option.textContent.toLowerCase()
                                        .normalize('NFD').replace(/[\u0300-\u036f]/g, "")
                                        ===
                                        response.neighborhood.toLowerCase()
                                            .normalize('NFD').replace(/[\u0300-\u036f]/g, "")) {
                                        bairroInput.value = option.value
                                    }
                                })
                        }
                    }

                })
                .catch(error => {
                    cepSearchButton.innerHTML = searchIcon
                    cepErrorArea.innerHTML = `
                    <div class="alert">
                        <div class="flex">
                            <div class="alert-content">Não possível encontrar este CEP</div>
                            </div>
                        </div>
                    </div>
                    `
                    Sentry.captureException(error)
                })
        }
    })

    const buttonWrapper = createElement('div', { class: "flex-column gap-8" })
    content.appendChild(buttonWrapper)

    const buttonContinuar = select('#continuar', content)
    buttonContinuar.addEventListener('click', () => {

        const loader = buttonLoader(buttonContinuar)
        loader.start()

        function validarCEP() {
            if (obrigatorioCEP) {
                if (cepInput.value.length < 8) {
                    toast('Preencha o CEP')
                    cepInput.setCustomValidity('Preencha o CEP')
                    cepInput.reportValidity()
                    return false
                } else {
                    return true
                }
            } else {
                return true
            }
        }
        if (inputIsValid(logradouroInput) &&
            inputIsValid(numeroInput) &&
            inputIsValid(bairroInput) &&
            inputIsValid(cidadeInput) &&
            inputIsValid(estadoInput) &&
            inputIsValid(telefoneInput) &&
            validarCEP()
        ) {

            const cidade = cidadeInput ? (cidadeInput.selectedOptions ? cidadeInput.selectedOptions[0].value : '') : ''
            const cidadeStr = cidadeInput ? (cidadeInput.selectedOptions ? cidadeInput.selectedOptions[0].textContent : '') : ''
            const estado = estadoInput ? (estadoInput.selectedOptions ? estadoInput.selectedOptions[0].textContent : '') : ''
            // Ponto escolhido no mapa. O SaveLocalEntrega só grava Latitude/Longitude (o
            // EnderecoEntrega não tem "coordenadas"); sem elas o ponto se perdia e o
            // pedido saía sem destino (MOGOE2E-1366).
            const pontoMapa = objEndereco && objEndereco.coordenadas
            const endereco = {
                rua: logradouroInput.value,
                numero: numeroInput.value,
                idBairro: bairroInput.value,
                bairroStr: bairroInput.selectedOptions ? bairroInput.selectedOptions[0].textContent : '',
                cidadeStr: cidadeStr,
                strCidade: cidadeStr,
                strEstado: estado,
                telefone: telefoneInput.value,
                cep: cepInput.value,
                complemento: complementoInput.value,
                referencia: referenciaInput.value,
                apelido: apelidoInput.value,
                coordenadas: objEndereco ? objEndereco.coordenadas : '',
                Latitude: pontoMapa && pontoMapa.lat ? pontoMapa.lat : null,
                Longitude: pontoMapa && pontoMapa.lng ? pontoMapa.lng : null
            }

            //Faz uma validação verificando se o bairro e rua são equivalentes ao cep, para evitar que o usuário coloque o endereço errado ou burle as regras de entrega
            validaBairro(endereco, (validacaoEndereco) => {
                if (validacaoEndereco.valido) {
                    salvaEndereco()
                } else {
                    exibeMensagemErroEndereco(validacaoEndereco, salvaEndereco, endereco)
                    loader.stop()
                }
            })

            //enderecoNaoEncontradoNaApi é um objeto que contém o endereço que não foi encontrado na API
            //Se o endereço não foi encontrado na API, o usuário pode escolher se deseja salvar o endereço mesmo assim
            function salvaEndereco(enderecoNaoEncontradoNaApi) {

                const errorArea = select('#error-area', content)
                const errorTemplate = message => {
                    return `
                    <div class="alert">
                        <div class="flex">
                            <div class="alert-content">${message}</div>
                            </div>
                        </div>
                    </div>
                    `
                }

                if (estabelecimento.tipoEntrega === "raio" || estabelecimento.tipoEntrega === "distancia") {
                    buscaRaioEndereco(endereco, salva)
                } else {
                    salva(true, enderecoNaoEncontradoNaApi)
                }

                function salva(valido, enderecoNaoEncontradoNaApi) {

                    if (!valido && (estabelecimento.tipoEntrega == "raio" || estabelecimento.tipoEntrega == "distancia")) {

                        loader.stop()

                        showMessageBox({
                            id: 'message-box-nao-entrega',
                            icon: 'warning',
                            message: 'O endereço não está dentro do raio de entrega da loja.',
                            classList: 'no-icon-background small',
                            default: true
                        })

                    } else {
                        if (idEnd) {
                            endereco.id = typeof idEnd == 'string' ? idEnd.parseNumber() : idEnd
                            endereco.StrBairro = endereco.bairroStr

                            const enderecoToAjax = endereco || enderecoNaoEncontradoNaApi
                            if (enderecoToAjax.numero == "SN") {
                                enderecoToAjax.numero = ""
                            }
                            $.ajax({
                                url: getUrlAction('Cadastros', 'SaveLocalEntrega'),
                                type: 'POST',
                                data: {
                                    str: JSON.stringify(endereco)
                                },
                                async: true,
                                success: function (response) {

                                    loader.stop()

                                    response = JSON.parse(response)

                                    if (response.lValid) {

                                        if (!idEnd) {
                                            usuario.enderecos.push(response.endereco)
                                        }

                                        usuario.enderecoPrincipal = response.endereco

                                        //Baseado no idEnd e no id do endereço, verifica se o endereço é o mesmo que está sendo editado
                                        const enderecoEditado = usuario.enderecos.find(end => end.Id == idEnd)
                                        if (enderecoEditado) {
                                            usuario.enderecos = usuario.enderecos.filter(end => end.Id != idEnd)
                                            usuario.enderecos.push(response.endereco)
                                        }

                                        const telaCadastro = select('#cadastrar-endereco')
                                        telaCadastro && telaCadastro.remove()

                                        const confirmarPedido = select('#confirmarPedido')
                                        confirmarPedido && confirmarPedido.click()
                                        wrapper.remove()

                                        const telaEndereco = select('#pagina-enderecos')
                                        if (telaEndereco) {
                                            telaEndereco.remove()
                                            enderecos()
                                        }

                                    } else {
                                        errorArea.innerHTML = errorTemplate('Ocorreu um erro ao cadastrar o endereço, tente novamente mais tarde.')
                                    }
                                },
                                error: function (response) {
                                    loader.stop()
                                    errorArea.innerHTML = errorTemplate('Ocorreu um erro ao cadastrar o endereço, tente novamente mais tarde')
                                    Sentry.captureException(response)
                                }
                            })
                        } else {
                            const enderecoToAjax = endereco || enderecoNaoEncontradoNaApi
                            if (enderecoToAjax.numero == "SN") {
                                enderecoToAjax.numero = ""
                            }

                            $.ajax({
                                url: getUrlAction('Cadastros', 'SaveLocalEntrega'),
                                type: 'POST',
                                data: {
                                    str: JSON.stringify(enderecoToAjax)
                                },
                                async: true,
                                success: function (response) {

                                    loader.stop()

                                    response = JSON.parse(response)

                                    if (response.lValid) {

                                        usuario.enderecoPrincipal = response.endereco
                                        usuario.enderecos.push(response.endereco)


                                        const telaCadastro = select('#cadastrar-endereco')
                                        telaCadastro && telaCadastro.remove()

                                        const confirmarPedido = select('#confirmarPedido')
                                        confirmarPedido && confirmarPedido.click()
                                        wrapper.remove()

                                        const telaEndereco = select('#pagina-enderecos')
                                        if (telaEndereco) {
                                            telaEndereco.remove()
                                            enderecos()
                                        }

                                    } else {
                                        errorArea.innerHTML = errorTemplate('Ocorreu um erro ao cadastrar o endereço, tente novamente mais tarde.')
                                    }
                                },
                                error: function (response) {
                                    loader.stop()
                                    errorArea.innerHTML = errorTemplate('Ocorreu um erro ao cadastrar o endereço, tente novamente mais tarde')
                                    Sentry.captureException(response)
                                }
                            })
                        }
                    }
                }
            }
        } else {
            loader.stop()
        }
    })

    const buttonCancelar = select('#cancelar', content)
    buttonCancelar.addEventListener('click', () => {
        wrapper.remove()
    })

    document.body.appendChild(wrapper)
}

export function selecionaBairroEquivalente(stringBairro, options) {

    const bairroEquivalente = options.find(option => {
        if (option.textContent) {
            return option.textContent.toLowerCase().includes(stringBairro.toLowerCase())
        }
    })

    return bairroEquivalente
}

export function validaBairro(endereco, callback) {

    if (endereco.cep) {
        buscaCep(endereco.cep, { providers: ['brasilapi', 'viacep', 'widenet'] })
            .then(response => {

                const removeCaracteresEspeciais = string => {
                    return string.normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, "")
                        .trim()
                        .replace(' ', '')
                        .toLowerCase()
                }

                const bairroAPI = removeCaracteresEspeciais(response.neighborhood)
                const bairroInformado = removeCaracteresEspeciais(endereco.bairroStr)

                const tudoCertoNaoValidaPeloBairro = !bairroAPI && endereco.bairroStr && endereco.idBairro && endereco.coordenadas && endereco.coordenadas.lat && endereco.coordenadas.lng

                if (bairroAPI != bairroInformado && !tudoCertoNaoValidaPeloBairro) {
                    callback({
                        valido: false,
                        idBairro: endereco.idBairro,
                        bairroAPI,
                        bairroInformado,
                        bairro: endereco.bairro,
                        bairroAPIDescricao: response.neighborhood,
                    })
                } else {
                    callback({ valido: true })
                }

            })
            .catch(error => {
                callback({ valido: true })
            })

    } else {
        callback({ valido: true })
    }
}


export async function buscaCoordenadasEstabelecimento(callback) {
    const address = estabelecimento.endereco.toString()
    if (!estabelecimento.api.geocoder) {
        estabelecimento.api.geocoder = new google.maps.Geocoder()
    }

    if (estabelecimento.api.geocoder && estabelecimento.api.geocoder.geocode) {
        const geocoderConfig = { 'address': address }
        estabelecimento.api.geocoder.geocode(geocoderConfig, callbackGeocoder)

        function callbackGeocoder(results, status) {

            if (status == google.maps.GeocoderStatus.OK) {

                const endereco = results[0]

                const latitude = endereco.geometry.location.lat();
                const longitude = endereco.geometry.location.lng();

                estabelecimento.endereco.coordenadas = latitude + ',' + longitude

                axios.get('Cadastros/SetCordenadasEstabelecimento', {
                    params: {
                        cordenadas: estabelecimento.endereco.coordenadas,
                        urlEmpresa: estabelecimento.urlEmpresa
                    }
                })
                    .then(response => {
                        console.log("Coordenadas salvas com sucesso")
                    })
                    .catch(error => {
                        console.error(error)
                        Sentry.captureException(error)
                    })

                callback && callback(estabelecimento.endereco.coordenadas)


            } else {

                Sentry.captureException(`Não foi possível encontrar a geolocalização do estabelecimento ${estabelecimento.urlEmpresa}`,
                    {
                        geocoderStatus: status,
                        geocoderResults: results,
                        endereco: address
                    }
                )

                callback({
                    erro: "Não foi possível encontrar a geolocalização do estabelecimento"
                })
            }

        }

    } else {
        Sentry.captureException('Google geocoder não encontrado')
    }
}

// Quanto o Google confia no ponto que devolveu. ROOFTOP é a coordenada do imóvel;
// GEOMETRIC_CENTER e APPROXIMATE são o centro de uma via, de um cruzamento ou de
// uma região inteira. partial_match significa que ele não casou tudo que foi
// pedido e completou por conta própria — desconta meio ponto para desempatar.
const RANK_PRECISAO_GEOCODE = {
    ROOFTOP: 4,
    RANGE_INTERPOLATED: 3,
    GEOMETRIC_CENTER: 2,
    APPROXIMATE: 1,
}

function precisaoGeocode(resultado) {
    if (!resultado || !resultado.geometry) {
        return 0
    }

    const base = RANK_PRECISAO_GEOCODE[resultado.geometry.location_type] || 0
    return resultado.partial_match ? base - 0.5 : base
}

export function buscaCoordenadasCliente(address, coordenadas, endereco) {
    return new Promise((resolve, reject) => {

        if (!address) {
            reject({ error: 'Endereço não encontrado' })
            Sentry.captureException('Endereço não encontrado ao executar o método buscaCoordenadasCliente')
        }

        if (coordenadas && coordenadas.lat && coordenadas.lng) {
            resolve({
                latitude: coordenadas.lat,
                longitude: coordenadas.lng
            })
        } else {
            if (!estabelecimento.api.geocoder) {
                estabelecimento.api.geocoder = new google.maps.Geocoder()
            }

            const geocodifica = (texto) => new Promise((res) => {
                if (!estabelecimento.api.geocoder || !estabelecimento.api.geocoder.geocode) {
                    res({ results: null, status: 'SCRIPT_LOAD_ERROR' })
                    return
                }

                estabelecimento.api.geocoder.geocode({ 'address': texto }, (results, status) => {
                    res({ results, status })
                })
            })

            geocodifica(address)
                .then((principal) => {
                    if (principal.status != google.maps.GeocoderStatus.OK || !principal.results || !principal.results[0]) {
                        //Rejeita a promisse caso ocorra algum erro
                        reject({
                            erro: principal.status
                        })
                        return
                    }

                    const escolhido = principal.results[0]

                    // Endereço que o Google não fixou: o ponto usado vira o centro da
                    // via ou um cruzamento, e é ele que define a taxa. Antes de aceitar,
                    // tenta de novo com o complemento na frente — é o que identifica o
                    // lugar quando a via não tem numeração confiável. Só troca se vier
                    // mais preciso, então endereço que já resolve bem não muda de valor
                    // e nem gasta uma segunda chamada.
                    if (precisaoGeocode(escolhido) >= RANK_PRECISAO_GEOCODE.RANGE_INTERPOLATED) {
                        return escolhido
                    }

                    const textoComComplemento = formatAddressGeocode(endereco)
                    if (!textoComComplemento || textoComComplemento == address) {
                        return escolhido
                    }

                    return geocodifica(textoComComplemento).then((alternativo) => {
                        const candidato = alternativo.status == google.maps.GeocoderStatus.OK
                            && alternativo.results
                            && alternativo.results[0]

                        if (candidato && precisaoGeocode(candidato) > precisaoGeocode(escolhido)) {
                            return candidato
                        }

                        return escolhido
                    })
                })
                .then((resultado) => {
                    if (!resultado) {
                        return
                    }

                    //Retorna um objeto contendo as coordenadas
                    resolve({
                        latitude: resultado.geometry.location.lat(),
                        longitude: resultado.geometry.location.lng()
                    })
                })
                .catch((error) => {
                    //Rejeita a promisse caso ocorra algum erro
                    reject({
                        erro: error
                    })

                    Sentry.captureException(error)
                })
        }
    })
}

// Ponto de entrega do endereço para o pedido (MOGOE2E-1366), em texto com ponto
// decimal. Vale o gravado no cadastro (escolhido no mapa); na falta, o localizado
// pelo texto nesta sessão (latitude/longitude minúsculos, do cálculo da taxa).
export function coordenadasEntrega(endereco) {
    if (!endereco) return null

    const pares = [
        [endereco.Latitude, endereco.Longitude],
        [endereco.latitude, endereco.longitude],
    ]

    for (const [lat, lng] of pares) {
        if (lat == null || lat === '' || lng == null || lng === '') continue

        const latitude = Number(lat)
        const longitude = Number(lng)
        if (Number.isFinite(latitude) && Number.isFinite(longitude) && !(latitude === 0 && longitude === 0)) {
            return { latitude: String(latitude), longitude: String(longitude) }
        }
    }

    return null
}

// Endereço sem ponto (digitado sem o mapa, editado ou cadastrado antes da correção):
// localiza pelo texto para o pedido não sair sem destino. Nunca rejeita: se o Google
// não estiver disponível ou não achar, o pedido segue sem coordenadas.
export function localizaEnderecoSemCoordenadas(endereco) {
    if (!endereco || coordenadasEntrega(endereco) || !estabelecimento.chaveAPIGoogleMaps || estabelecimento.googleIndisponivel) {
        return Promise.resolve()
    }

    return criaInstanciaGeocoder()
        .then(() => buscaCoordenadasCliente(formatAddress(endereco), null, endereco))
        .then(({ latitude, longitude }) => {
            endereco.latitude = latitude
            endereco.longitude = longitude
        })
        .catch(() => { })
}

function exibeMensagemErroEndereco(validacao, callback, endereco) {
    const wrapper = createElement('div', { class: 'wrapper-solicita-endereco' }, `
    <div class="wrapper-content">    
            <div class="font-color-primary font-14 font-weight-500">
                O bairro selecionado não é igual ao bairro do CEP
            </div>
           
            <div class="flex flex-column gap-4 w-100">         
                <div class="font-12 font-500 text-start">Bairro registrado no CEP</div>
                <div class="input-wrapper"><input type="text" value="${validacao.bairroAPIDescricao}" readonly disabled></div>
            </div>

            <div class="flex flex-column gap-4 w-100">         
                <div class="font-12 font-500 text-start">Bairro selecionado</div>
                <div class="input-wrapper wrapper-select"></div>
            </div>

            <div class="info-yellow">
                Caso você tenha certeza que o bairro selecionado é o correto, clique em "Continuar",
                caso contrário, você pode cadastrar outro endereço ou retirar seu pedido no estabelecimento.
            </div>

            <div class="w-100 flex-column gap-8 wrapper-inputs">  
                <div id="error-area"></div>
                <div class="flex gap-8 u-m-t-8">
                    <button id="cancelar-validacao" class="btn-transparent">Retirar no local</button>
                    <button id="continuar-validacao" class="btn-azul">Continuar</button>
                </div>
            </div>

        </div>
    </div>
    `)

    const wrapperInput = select('.wrapper-select', wrapper)
    const selectElement = createElement('select')
    wrapperInput.appendChild(selectElement)

    estabelecimento.entrega.bairros.forEach((enderecoMogoSmart) => {
        selectElement.innerHTML += `<option value="${enderecoMogoSmart.Id}" > ${enderecoMogoSmart.Descricao}</option> `
    })

    selectElement.value = validacao.idBairro

    document.body.appendChild(wrapper)

    const continuar = select('#continuar-validacao')
    const cancelar = select('#cancelar-validacao')

    continuar.addEventListener('click', () => {
        endereco.idBairro = Number(selectElement.value)
        wrapper.remove()
        callback(endereco)
    })

    cancelar.addEventListener('click', () => {
        wrapper.remove()

        const buttonBuscarNoLocal = select('[for="inp-buscar"]')
        buttonBuscarNoLocal && buttonBuscarNoLocal.click()

        const wrapperSolicitaEndereco = select('.wrapper-solicita-endereco')
        if (wrapperSolicitaEndereco) {
            wrapperSolicitaEndereco.remove()
        }

        const confirmarItens = select('#confirmarPedido')
        confirmarItens && confirmarItens.click()

    })
}

/*Funções genéricas para calcular taxa de entrega por raio*/
export function buscaValorTaxaEntregaPorRaio(endereco) {
    return new Promise((resolve, reject) => {
        axios.get('Pedido/GetVlrEntregaRaio', {
            params: {
                raio: endereco.Raio,
                urlEmpresa: estabelecimento.urlEmpresa,
                idEndereco: endereco.Id,
                // As duas caixas: o cálculo em sessão grava minúsculo e o endereço
                // vindo do banco traz Latitude/Longitude maiúsculos. Lendo só uma
                // delas isto ia vazio, e sem coordenada o ValidaCoordenadasEntrega
                // do MogoSmart não checa os polígonos de restrição de entrega.
                latitude: endereco.latitude || endereco.Latitude || "",
                longitude: endereco.longitude || endereco.Longitude || ""
            }
        }).then(response => {
            try {
                resolve(response.data)
            } catch (error) {
                Sentry.captureException(error)
                console.error(error)
                reject({
                    error: error
                })
            }

        })
    })
}

export function buscaRaioEndereco(endereco, callback) {


    //Caso o endereço do cliente já tenha raio, então não precisa buscar novamente
    if (endereco && endereco.Raio) {

        buscaValorTaxaEntregaPorRaio(endereco)
            .then(response => {
                if (response.PodeEntregar) {
                    callback(response)
                } else {
                    callback(false)
                }
            }).catch(error => {
                toast("Ocorreu um erro ao buscar o raio do endereço. Tente novamente mais tarde.")
                callback(false)
            })

    } else {

        if (!estabelecimento.api.geocoder) {
            criaInstanciaGeocoder()
                .then(() => { executaBusca() })
        } else {
            executaBusca()
        }

        function executaBusca() {
            const enderecoFormatado = formatAddress(endereco)
            buscaCoordenadasCliente(enderecoFormatado, endereco.coordenadas, endereco)
                .then(coordenadasCliente => {
                    try {
                        //Loja
                        if (!estabelecimento.endereco.coordenadas) {
                            buscaCoordenadasEstabelecimento(afterCoordenadasEstabelecimento)
                        } else {
                            afterCoordenadasEstabelecimento()
                        }

                        function afterCoordenadasEstabelecimento(response) {
                            if (response && response.erro) {
                                toast("Ocorreu um erro, tente novamente mais tarde")
                                console.error(response.erro)
                                callback(false)
                                return
                            }

                            const [latitudeLoja, lonjitudeLoja] = estabelecimento.endereco.coordenadas.split(',')

                            //Endereços
                            const localizacaoLoja = new google.maps.LatLng(latitudeLoja, lonjitudeLoja);
                            const localizacaoCliente = new google.maps.LatLng(coordenadasCliente.latitude, coordenadasCliente.longitude);

                            if (estabelecimento.tipoEntrega === "raio" || estabelecimento.TipoTaxaEntrega == 1) {
                                //Calcula raio (distância (km) em linha reta de um ponto a outro)
                                endereco.Raio = google.maps.geometry.spherical.computeDistanceBetween(localizacaoLoja, localizacaoCliente) / 1000;
                                endereco.latitude = coordenadasCliente.latitude
                                endereco.longitude = coordenadasCliente.longitude
                                endereco.Latitude = coordenadasCliente.latitude
                                endereco.Longitude = coordenadasCliente.longitude

                                buscaValorTaxaEntregaPorRaio(endereco)
                                    .then(response => {
                                        if (response.PodeEntregar) {
                                            callback(response)
                                        } else {
                                            callback(false)
                                        }
                                    }).catch(response => {
                                        toast("Ocorreu um erro ao buscar o raio do endereço. Tente novamente mais tarde.")
                                        callback(false)
                                    })
                            }
                            else if (estabelecimento.tipoEntrega === "distancia" || estabelecimento.TipoTaxaEntrega == 2) {

                                const directionsService = new google.maps.DirectionsService();

                                //Calcula a distancia em km por rota entre os endereços
                                const routeConfig = {
                                    origin: localizacaoLoja,
                                    destination: localizacaoCliente,
                                    travelMode: google.maps.TravelMode.DRIVING
                                }

                                directionsService.route(routeConfig, callbackSuccess);

                                function callbackSuccess(response, status) {

                                    if (status === google.maps.DirectionsStatus.OK) {
                                        endereco.Raio = response.routes[0].legs[0].distance.value / 1000;
                                        endereco.latitude = coordenadasCliente.latitude
                                        endereco.longitude = coordenadasCliente.longitude
                                        endereco.Latitude = coordenadasCliente.latitude
                                        endereco.Longitude = coordenadasCliente.longitude

                                        buscaValorTaxaEntregaPorRaio(endereco)
                                            .then(result => {
                                                if (result.PodeEntregar) {
                                                    callback(result)
                                                } else {
                                                    callback(false)
                                                }
                                            }).catch(() => {
                                                toast("Ocorreu um erro, tente novamente mais tarde")
                                                callback(false)
                                            })

                                    }
                                    else {
                                        callback(false)
                                    }

                                }
                            }
                        }

                    } catch (error) {
                        Sentry.captureException(error)
                        console.error(error)
                        callback(false)
                    }
                })
                .catch(response => {
                    if (response.error) {
                        Sentry.captureException(error)
                        console.error(error)
                    }
                })
        }

    }

}

export function validaCoordenadasEntrega() {
    return new Promise((resolve, reject) => {

        const endereco = usuario?.enderecoSelecionado || usuario?.enderecoPrincipal;
        if (!endereco) {
            return
        }

        const enderecoFormatado = formatAddress(endereco)
        if (!estabelecimento.api.geocoder) {
            criaInstanciaGeocoder()
                .then(() => { executaBusca() })
        } else {
            executaBusca()
        }

        const executaBusca = () => {
            buscaCoordenadasCliente(enderecoFormatado)
        }

        axios.get('Pedido/ValidaCoordenadasEntrega', {
            params: {
                urlEmpresa: estabelecimento.urlEmpresa,
                latitude: endereco.Raio,
                longitude: endereco.Id
            }
        }).then(response => {
            try {
                resolve(response.data)
            } catch (error) {
                Sentry.captureException(error)
                console.error(error)
                reject({
                    error: error
                })
            }
        })
    })
}

export function buscaLocalizacaoUsuario() {

    criaPagina()

    if (!estabelecimento.api.geocoder) {
        criaInstanciaGeocoder()
            .then(() => { callback() })
    } else {
        callback()
    }

    function callback() {
        if (!estabelecimento.endereco.coordenadas) {
            buscaCoordenadasEstabelecimento(buscaLocalizacao)
        } else {
            buscaLocalizacao()
        }
    }
    function buscaLocalizacao() {

        const wrapper = select('#cadastrar-endereco')
        const buscaPorLocalizacao = select('#busca-localizacao')
        const inputPesquisa = select('#buscar-endereco', wrapper)
        const confirmarButton = select('#confirmar-button')
        let objEndereco = {}

        inputPesquisa && inputPesquisa.addEventListener('input', (e) => {
            if (inputPesquisa.value.length > 3) {
                if (estabelecimento.api.geocoder && estabelecimento.api.geocoder.geocode) {
                    //loader.checked = true
                    //Busca endereço pela api geocoder restringindo por um raio de 100km
                    estabelecimento.api.geocoder.geocode({
                        address: inputPesquisa.value,
                        componentRestrictions: {
                            country: 'br',
                            locality: estabelecimento.endereco.cidade
                        },
                        bounds: new google.maps.Circle({
                            center: new google.maps.LatLng(
                                estabelecimento.endereco.coordenadas.split(',')[0],
                                estabelecimento.endereco.coordenadas.split(',')[1]),
                            radius: 10000
                        }).getBounds()
                    }, function (results, status) {

                        //loader.checked = false
                        if (status == google.maps.GeocoderStatus.OK) {

                            if (
                                results &&
                                results.length > 0 &&
                                results.some(result => result.address_components.find(item => item.types.includes('route')))
                            ) {

                                const wrapperResultados = select('.results')
                                wrapperResultados.innerHTML = ''
                                results.forEach(result => {
                                    if (
                                        result.address_components.find(item => item.types.includes('route'))
                                    ) {

                                        const endereco = formataEnderecoGeocoder(result)
                                        let subtitle = [endereco.cidade, endereco.estado].join(', ')
                                        if (endereco.cep) {
                                            subtitle += ' - ' + endereco.cep
                                        }
                                        const wrapperEndereco = createElement('div', { class: 'address-card flex-between' }, `                                    
                                            <div class="flex gap-4">
                                                <svg width="65" height="64" viewBox="0 0 65 64" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 42px;height: 30px;"><path fill-rule="evenodd" clip-rule="evenodd" d="M63.828 7.39997C63.828 8.08297 63.26 8.63297 62.557 8.63297C61.856 8.63297 61.287 8.08297 61.287 7.39997C61.287 6.71997 61.856 6.16797 62.557 6.16797C63.26 6.16797 63.828 6.71997 63.828 7.39997ZM11.718 13.6C11.718 14.3 11.15 14.872 10.447 14.872C10.1957 14.872 9.94999 14.7975 9.74099 14.6578C9.532 14.5182 9.36909 14.3198 9.27287 14.0876C9.17664 13.8554 9.15141 13.5999 9.20037 13.3534C9.24933 13.1069 9.37028 12.8804 9.54794 12.7026C9.72559 12.5248 9.95197 12.4037 10.1984 12.3545C10.4449 12.3054 10.7005 12.3304 10.9327 12.4264C11.165 12.5225 11.3636 12.6852 11.5033 12.8941C11.6431 13.103 11.7178 13.3486 11.718 13.6M60.275 46.928C60.275 47.608 59.706 48.161 59.005 48.161C58.305 48.161 57.734 47.608 57.734 46.928C57.734 46.248 58.304 45.695 59.005 45.695C59.706 45.695 60.275 46.248 60.275 46.928ZM4.71002 56.563C4.71681 56.7339 4.68901 56.9044 4.62829 57.0642C4.56758 57.2241 4.47519 57.3701 4.35669 57.4934C4.23818 57.6167 4.09599 57.7148 3.93865 57.7818C3.7813 57.8488 3.61204 57.8834 3.44102 57.8834C3.27 57.8834 3.10074 57.8488 2.9434 57.7818C2.78605 57.7148 2.64386 57.6167 2.52535 57.4934C2.40685 57.3701 2.31446 57.2241 2.25375 57.0642C2.19303 56.9044 2.16524 56.7339 2.17202 56.563C2.1813 56.2324 2.31912 55.9186 2.55618 55.6881C2.79325 55.4576 3.11087 55.3286 3.44152 55.3286C3.77217 55.3286 4.08979 55.4576 4.32686 55.6881C4.56392 55.9186 4.70174 56.2324 4.71102 56.563M30.748 18.594C30.748 18.9308 30.6142 19.2538 30.376 19.492C30.1379 19.7302 29.8148 19.864 29.478 19.864C29.1412 19.864 28.8182 19.7302 28.58 19.492C28.3418 19.2538 28.208 18.9308 28.208 18.594C28.208 18.2571 28.3418 17.9341 28.58 17.6959C28.8182 17.4578 29.1412 17.324 29.478 17.324C29.8148 17.324 30.1379 17.4578 30.376 17.6959C30.6142 17.9341 30.748 18.2571 30.748 18.594" fill="#6C63FF"></path><path d="M33 9C24.7071 9 18 15.886 18 24.4C18 36.148 27.0214 39.338 30.9214 51.416C31.2214 52.34 32.0357 53 33 53C33.9643 53 34.7786 52.34 35.0786 51.416C38.9786 39.338 48 36.148 48 24.4C48 15.886 41.2929 9 33 9ZM33 29.9C30.0429 29.9 27.6429 27.436 27.6429 24.4C27.6429 21.364 30.0429 18.9 33 18.9C35.9571 18.9 38.3571 21.364 38.3571 24.4C38.3571 27.436 35.9571 29.9 33 29.9Z" fill="#6C63FF"></path></svg>
                                                <div class="flex flex-column gap-4">
                                                    <div class="w-100 font-13 font-500 color-blue">${[endereco.rua, endereco.bairro].join(', ')}</div>
                                                    <div class="w-100">${subtitle}</div>
                                                </div>
                                            </div>
                                            <svg class="arrow" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.21967 3.21967C6.51256 2.92678 6.98744 2.92678 7.28033 3.21967L11.5303 7.46967C11.8232 7.76256 11.8232 8.23744 11.5303 8.53033L7.28033 12.7803C6.98744 13.0732 6.51256 13.0732 6.21967 12.7803C5.92678 12.4874 5.92678 12.0126 6.21967 11.7197L9.93934 8L6.21967 4.28033C5.92678 3.98744 5.92678 3.51256 6.21967 3.21967Z" fill="currentColor" style="color: #6c63ff;"></path></svg>
                                            `)
                                        ripple(wrapperEndereco)
                                        wrapperEndereco.addEventListener('click', () => {
                                            //inicializa o mapa passando a lat e long
                                            inicializaMapa(endereco.coordenadas.lat, endereco.coordenadas.lng, endereco)
                                            wrapperResultados.innerHTML = ''
                                        })
                                        wrapperResultados.appendChild(wrapperEndereco)
                                    }
                                })

                                const nenhumEncontrado = createElement('div', { class: 'address-card flex-between' }, `
                                    <div class="flex gap-4">
                                        <svg width="65" height="64" viewBox="0 0 65 64" fill="none" xmlns="http://www.w3.org/2000/svg" style=" width: 42px; height: 30px; "> <path opacity="0.2" d="M33 58.129C47.4318 58.129 59.131 46.4306 59.131 32C59.131 17.5693 47.4318 5.87097 33 5.87097C18.5683 5.87097 6.86902 17.5693 6.86902 32C6.86902 46.4306 18.5683 58.129 33 58.129Z" fill="#6C63FF"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M63.828 7.39997C63.828 8.08297 63.26 8.63297 62.557 8.63297C61.856 8.63297 61.287 8.08297 61.287 7.39997C61.287 6.71997 61.856 6.16797 62.557 6.16797C63.26 6.16797 63.828 6.71997 63.828 7.39997ZM11.718 13.6C11.718 14.3 11.15 14.872 10.447 14.872C10.1957 14.872 9.94999 14.7975 9.74099 14.6578C9.532 14.5182 9.36909 14.3198 9.27287 14.0876C9.17664 13.8554 9.15141 13.5999 9.20037 13.3534C9.24933 13.1069 9.37028 12.8804 9.54794 12.7026C9.72559 12.5248 9.95197 12.4037 10.1984 12.3545C10.4449 12.3054 10.7005 12.3304 10.9327 12.4264C11.165 12.5225 11.3636 12.6852 11.5033 12.8941C11.6431 13.103 11.7178 13.3486 11.718 13.6ZM60.275 46.928C60.275 47.608 59.706 48.161 59.005 48.161C58.305 48.161 57.734 47.608 57.734 46.928C57.734 46.248 58.304 45.695 59.005 45.695C59.706 45.695 60.275 46.248 60.275 46.928ZM4.71002 56.563C4.71681 56.7339 4.68901 56.9044 4.62829 57.0642C4.56758 57.2241 4.47519 57.3701 4.35669 57.4934C4.23818 57.6167 4.09599 57.7148 3.93865 57.7818C3.7813 57.8488 3.61204 57.8834 3.44102 57.8834C3.27 57.8834 3.10074 57.8488 2.9434 57.7818C2.78605 57.7148 2.64386 57.6167 2.52535 57.4934C2.40685 57.3701 2.31446 57.2241 2.25375 57.0642C2.19303 56.9044 2.16524 56.7339 2.17202 56.563C2.1813 56.2324 2.31912 55.9186 2.55618 55.6881C2.79325 55.4576 3.11087 55.3286 3.44152 55.3286C3.77217 55.3286 4.08979 55.4576 4.32686 55.6881C4.56392 55.9186 4.70174 56.2324 4.71102 56.563M30.748 18.594C30.748 18.9308 30.6142 19.2538 30.376 19.492C30.1379 19.7302 29.8148 19.864 29.478 19.864C29.1412 19.864 28.8182 19.7302 28.58 19.492C28.3418 19.2538 28.208 18.9308 28.208 18.594C28.208 18.2571 28.3418 17.9341 28.58 17.6959C28.8182 17.4578 29.1412 17.324 29.478 17.324C29.8148 17.324 30.1379 17.4578 30.376 17.6959C30.6142 17.9341 30.748 18.2571 30.748 18.594Z" fill="#6C63FF"></path> <path d="M32.1294 14.5407C32.5122 13.8633 33.4878 13.8633 33.8706 14.5407L52.0755 46.758C52.4522 47.4247 51.9706 48.25 51.2049 48.25H14.7951C14.0294 48.25 13.5478 47.4247 13.9245 46.758L32.1294 14.5407Z" fill="#DAD8F7"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M32.1051 13.4976C31.8466 13.0121 31.1534 13.0121 30.8949 13.4977L14.2043 44.8527C13.96 45.3118 14.2912 45.8665 14.8094 45.8665H48.1905C48.7089 45.8665 49.0399 45.3118 48.7957 44.8527L32.1051 13.4976ZM27.2643 11.5492C29.0736 8.15026 33.9264 8.15026 35.7357 11.5492L52.4263 42.9045C54.1363 46.1167 51.8181 50 48.1905 50H14.8094C11.1818 50 8.86374 46.1167 10.5737 42.9045L27.2643 11.5492ZM34.2444 38.9774C34.2444 40.4994 33.0157 41.7331 31.5 41.7331C29.9843 41.7331 28.7556 40.4994 28.7556 38.9774C28.7556 37.4555 29.9843 36.2218 31.5 36.2218C33.0157 36.2218 34.2444 37.4555 34.2444 38.9774ZM33.5583 24.5104C33.5583 23.3689 32.6368 22.4436 31.5 22.4436C30.3633 22.4436 29.4417 23.3689 29.4417 24.5104V31.3995C29.4417 32.5409 30.3633 33.4662 31.5 33.4662C32.6368 33.4662 33.5583 32.5409 33.5583 31.3995V24.5104Z" fill="#6C63FF"></path> </svg>
                                    <div class="flex flex-column gap-4">
                                        <div class="w-100 font-13 font-500 color-blue">Não encontrou seu endereço?</div>
                                        <div class="w-100">Clique aqui para cadastrar manualmente</div>
                                    </div>
                                    </div>
                                    <svg class="arrow" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.21967 3.21967C6.51256 2.92678 6.98744 2.92678 7.28033 3.21967L11.5303 7.46967C11.8232 7.76256 11.8232 8.23744 11.5303 8.53033L7.28033 12.7803C6.98744 13.0732 6.51256 13.0732 6.21967 12.7803C5.92678 12.4874 5.92678 12.0126 6.21967 11.7197L9.93934 8L6.21967 4.28033C5.92678 3.98744 5.92678 3.51256 6.21967 3.21967Z" fill="currentColor" style="
                                        color: #6c63ff;
                                        "></path>
                                    </svg>
                                `)

                                nenhumEncontrado.addEventListener('click', () => { novoEndereco() })
                                wrapperResultados.appendChild(nenhumEncontrado)
                            } else {
                                const wrapperResultados = select('.results')
                                wrapperResultados.innerHTML = `
                                <div id="cadastro-manual" class="address-card flex-between">
                                    <div class="flex gap-4">
                                        <svg width="65" height="64" viewBox="0 0 65 64" fill="none" xmlns="http://www.w3.org/2000/svg" style=" width: 42px; height: 30px; "> <path opacity="0.2" d="M33 58.129C47.4318 58.129 59.131 46.4306 59.131 32C59.131 17.5693 47.4318 5.87097 33 5.87097C18.5683 5.87097 6.86902 17.5693 6.86902 32C6.86902 46.4306 18.5683 58.129 33 58.129Z" fill="#6C63FF"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M63.828 7.39997C63.828 8.08297 63.26 8.63297 62.557 8.63297C61.856 8.63297 61.287 8.08297 61.287 7.39997C61.287 6.71997 61.856 6.16797 62.557 6.16797C63.26 6.16797 63.828 6.71997 63.828 7.39997ZM11.718 13.6C11.718 14.3 11.15 14.872 10.447 14.872C10.1957 14.872 9.94999 14.7975 9.74099 14.6578C9.532 14.5182 9.36909 14.3198 9.27287 14.0876C9.17664 13.8554 9.15141 13.5999 9.20037 13.3534C9.24933 13.1069 9.37028 12.8804 9.54794 12.7026C9.72559 12.5248 9.95197 12.4037 10.1984 12.3545C10.4449 12.3054 10.7005 12.3304 10.9327 12.4264C11.165 12.5225 11.3636 12.6852 11.5033 12.8941C11.6431 13.103 11.7178 13.3486 11.718 13.6ZM60.275 46.928C60.275 47.608 59.706 48.161 59.005 48.161C58.305 48.161 57.734 47.608 57.734 46.928C57.734 46.248 58.304 45.695 59.005 45.695C59.706 45.695 60.275 46.248 60.275 46.928ZM4.71002 56.563C4.71681 56.7339 4.68901 56.9044 4.62829 57.0642C4.56758 57.2241 4.47519 57.3701 4.35669 57.4934C4.23818 57.6167 4.09599 57.7148 3.93865 57.7818C3.7813 57.8488 3.61204 57.8834 3.44102 57.8834C3.27 57.8834 3.10074 57.8488 2.9434 57.7818C2.78605 57.7148 2.64386 57.6167 2.52535 57.4934C2.40685 57.3701 2.31446 57.2241 2.25375 57.0642C2.19303 56.9044 2.16524 56.7339 2.17202 56.563C2.1813 56.2324 2.31912 55.9186 2.55618 55.6881C2.79325 55.4576 3.11087 55.3286 3.44152 55.3286C3.77217 55.3286 4.08979 55.4576 4.32686 55.6881C4.56392 55.9186 4.70174 56.2324 4.71102 56.563M30.748 18.594C30.748 18.9308 30.6142 19.2538 30.376 19.492C30.1379 19.7302 29.8148 19.864 29.478 19.864C29.1412 19.864 28.8182 19.7302 28.58 19.492C28.3418 19.2538 28.208 18.9308 28.208 18.594C28.208 18.2571 28.3418 17.9341 28.58 17.6959C28.8182 17.4578 29.1412 17.324 29.478 17.324C29.8148 17.324 30.1379 17.4578 30.376 17.6959C30.6142 17.9341 30.748 18.2571 30.748 18.594Z" fill="#6C63FF"></path> <path d="M32.1294 14.5407C32.5122 13.8633 33.4878 13.8633 33.8706 14.5407L52.0755 46.758C52.4522 47.4247 51.9706 48.25 51.2049 48.25H14.7951C14.0294 48.25 13.5478 47.4247 13.9245 46.758L32.1294 14.5407Z" fill="#DAD8F7"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M32.1051 13.4976C31.8466 13.0121 31.1534 13.0121 30.8949 13.4977L14.2043 44.8527C13.96 45.3118 14.2912 45.8665 14.8094 45.8665H48.1905C48.7089 45.8665 49.0399 45.3118 48.7957 44.8527L32.1051 13.4976ZM27.2643 11.5492C29.0736 8.15026 33.9264 8.15026 35.7357 11.5492L52.4263 42.9045C54.1363 46.1167 51.8181 50 48.1905 50H14.8094C11.1818 50 8.86374 46.1167 10.5737 42.9045L27.2643 11.5492ZM34.2444 38.9774C34.2444 40.4994 33.0157 41.7331 31.5 41.7331C29.9843 41.7331 28.7556 40.4994 28.7556 38.9774C28.7556 37.4555 29.9843 36.2218 31.5 36.2218C33.0157 36.2218 34.2444 37.4555 34.2444 38.9774ZM33.5583 24.5104C33.5583 23.3689 32.6368 22.4436 31.5 22.4436C30.3633 22.4436 29.4417 23.3689 29.4417 24.5104V31.3995C29.4417 32.5409 30.3633 33.4662 31.5 33.4662C32.6368 33.4662 33.5583 32.5409 33.5583 31.3995V24.5104Z" fill="#6C63FF"></path> </svg>
                                    <div class="flex flex-column gap-4">
                                        <div class="w-100 font-13 font-500">Nenhum resultado encontrado.</div>
                                        <div class="w-100">Clique aqui para cadastrar manualmente</div>
                                    </div>
                                    </div>
                                    <svg class="arrow" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.21967 3.21967C6.51256 2.92678 6.98744 2.92678 7.28033 3.21967L11.5303 7.46967C11.8232 7.76256 11.8232 8.23744 11.5303 8.53033L7.28033 12.7803C6.98744 13.0732 6.51256 13.0732 6.21967 12.7803C5.92678 12.4874 5.92678 12.0126 6.21967 11.7197L9.93934 8L6.21967 4.28033C5.92678 3.98744 5.92678 3.51256 6.21967 3.21967Z" fill="currentColor" style="
                                        color: #6c63ff;
                                        "></path>
                                    </svg>
                                </div>                                
                                `

                                const buttonCadstroManual = select('#cadastro-manual', wrapperResultados)
                                buttonCadstroManual.addEventListener('click', () => {
                                    novoEndereco()
                                })
                            }
                        }
                    }
                    )
                }
            } else if (inputPesquisa.value.length == 0) {
                const results = select('.results')
                results.innerHTML = ''
            }

        })

        if (navigator.geolocation) {
            buscaPorLocalizacao.addEventListener('click', (e) => {
                const results = select('.results')
                if (results) {
                    results.innerHTML = ''
                }
                // verifica se o navegador tem suporte a geolocalização
                navigator.geolocation.getCurrentPosition(
                    function (position) {
                        inicializaMapa(position.coords.latitude, position.coords.longitude)
                    },
                    function (error) {

                        if (error.code == 1) {
                            toast("O acesso à localização foi negado pelo seu dispositivo")
                        } else {
                            toast("Não foi possível obter sua localização")
                        }

                        console.log('Erro ao obter localização.', error);
                        inicializaMapa()
                    });
            })
        }

        document.body.style.overflow = 'hidden'

        let mapa, marker

        const enderecoElementoRua = select('#endereco-rua')
        const enderecoElementoSubtitulo = select('#endereco-subtitulo')
        const enderecoElementoNumero = select('#endereco-numero')
        const confirmarEndereco = select('.confirmar-endereco')

        let numeroDigitado
        //se o usuario digitar o número do endereço, não modifica o input pela api
        if (enderecoElementoNumero) {
            enderecoElementoNumero.addEventListener('keyup', () => {
                if (enderecoElementoNumero.value) {
                    numeroDigitado = true
                    objEndereco.numero = enderecoElementoNumero.value
                } else {
                    numeroDigitado = false
                    objEndereco.numero = ""
                }
            })
        }

        enderecoElementoNumero.addEventListener('input', (event) => {
            numberInputChanged()
        })

        confirmarButton.addEventListener('click', () => {
            if (enderecoElementoNumero.value != '') {
                novoEndereco(objEndereco)
            } else {
                toast('Por favor, digite o número do endereço')
            }
        })

        function numberInputChanged() {

            if (enderecoElementoNumero) {
                objEndereco.numero = enderecoElementoNumero.value
            }

            enderecoElementoNumero.classList.add('input-changed')
            setTimeout(() => {
                enderecoElementoNumero.classList.remove('input-changed')
            }, 500)
        }

        async function inicializaMapa(latitude, longitude, endereco) {

            let coordenadas = estabelecimento.endereco.coordenadas
            if (!coordenadas) {
                buscaCoordenadasEstabelecimento(inicializaMapa)
            } else {

                if (mapa) {
                    atualizaEnderecoMapa()
                } else {
                    criaInstanciaMapa(atualizaEnderecoMapa)
                }

                const navigatorGeolocation = select('.geolocation-map')
                if (navigatorGeolocation) {
                    navigatorGeolocation.remove()
                }

                function atualizaEnderecoMapa() {
                    mapa.setCenter(new google.maps.LatLng(latitude, longitude))

                    //muda a posicao do marker
                    marker.setPosition(new google.maps.LatLng(latitude, longitude))

                    //muda o zoom do mapa para 17
                    mapa.setZoom(18)

                    alteraEnderecoFooter(endereco)
                }

            }



            function criaInstanciaMapa(callback) {

                //cria o marker e mantém ele sempre no centro da tela
                let [lat, lng] = estabelecimento.endereco.coordenadas.split(',')

                if (latitude && longitude) {
                    [lat, lng] = [latitude, longitude]
                }

                //Cria o mapa apenas com o botão de localização e movimenta o marker conforme a movimentação da câmera
                //cria o mapa com o botão para localizar o usuário

                mapa = new google.maps.Map(select('#map', wrapper), {
                    center: { lat: Number(lat), lng: Number(lng) },
                    zoom: 15,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    streetViewControl: false,
                    mapTypeControl: false,
                    zoomControl: false,
                    fullscreenControl: false,
                    gestureHandling: 'greedy',
                });

                select('#map').style.pointerEvents = 'all'

                marker = new google.maps.Marker({
                    position: { lat: Number(lat), lng: Number(lng) },
                    map: mapa,
                    title: 'Localização do usuário',
                });

                var isDragging = false;
                //Cria o evento de movimentação do marker e exibe no console a localização
                /*map.addListener('center_changed', function (event) {
                    marker.setPosition(map.getCenter())
                    if (!isDragging) {
                        buscaEndereco(marker)
                    }
                })*/

                //Enquanto o usuario faz o movimento de drag, atualiza o marker
                mapa.addListener('drag', function (event) {
                    isDragging = true;
                    marker.setPosition(mapa.getCenter())
                })

                mapa.addListener('dragstart', function (event) {
                    isDragging = true;
                })

                mapa.addListener('dragend', function (event) {
                    marker.setPosition(mapa.getCenter())
                    buscaEndereco(marker)
                    isDragging = false
                })

                callback && callback()
            }

        }

        function buscaEndereco(marker) {

            //pega a latitude e longitude
            const lat = marker.getPosition().lat()
            const lng = marker.getPosition().lng()

            //busca o endereço com base na latitude e longitude
            const latlng = { lat, lng };

            estabelecimento.api.geocoder.geocode({ 'location': latlng }, function (results, status) {
                if (status === 'OK') {
                    if (results[0]) {
                        const enderecoFormatado = results[0].formatted_address
                        const enderecoSplit = enderecoFormatado.split(',')
                        const enderecoFinal = enderecoSplit[0] + ',' + enderecoSplit[1]
                        const enderecoComponents = results[0].address_components


                        const findComponent = (component, property) => {
                            const item = enderecoComponents.find(componente => componente.types.includes(component))
                            return item ? item[property] : null
                        }

                        const endereco = {
                            rua: findComponent('route', 'long_name'),
                            bairro: findComponent('sublocality', 'long_name'),
                            cidade: findComponent('administrative_area_level_2', 'long_name'),
                            estado: findComponent('administrative_area_level_1', 'short_name'),
                            cep: findComponent('postal_code', 'long_name'),
                            numero: findComponent('street_number', 'long_name'),
                            enderecoFormatado: enderecoFinal,
                            coordenadas: {
                                lat: results[0].geometry.location.lat(),
                                lng: results[0].geometry.location.lng()
                            }
                        }
                        enderecoElementoRua.textContent = endereco.rua || ""
                        enderecoElementoSubtitulo.textContent = [endereco.bairro, endereco.cidade, endereco.estado].filter(item => item).join(', ')
                        if (!numeroDigitado) {
                            enderecoElementoNumero.value = endereco.numero || ""
                        }
                        confirmarEndereco.classList.add('active')

                        objEndereco = endereco

                        numberInputChanged(enderecoElementoNumero)

                    } else {
                        toast('Não foi possível encontrar o endereço');
                    }
                } else {
                    toast('Não foi possível encontrar o endereço');
                }
            });
        }

        function alteraEnderecoFooter(endereco) {

            if (!endereco) {
                endereco = {}
                buscaEndereco(marker)
            } else {
                objEndereco = endereco
            }

            enderecoElementoRua.textContent = endereco.rua || ""
            enderecoElementoSubtitulo.textContent = [endereco.bairro, endereco.cidade, endereco.estado].filter(item => item).join(', ')
            if (!numeroDigitado) {
                enderecoElementoNumero.value = endereco.numero || ""
            }
            confirmarEndereco.classList.add('active')
            numberInputChanged(enderecoElementoNumero)

        }
    }

    function criaPagina() {
        const wrapper = createElement('div', { class: 'wrapper-cadastro-endereco', id: 'cadastrar-endereco' })

        let geolocationHTML = ""
        if (navigator.geolocation) {
            geolocationHTML = `
            <div id="busca-localizacao" class="flex justify-center align-center gap-8 font-12 color-blue u-font-w-500 u-p-16">
                <svg class="color-blue" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 5.09091C6.39273 5.09091 5.09091 6.39273 5.09091 8C5.09091 9.60727 6.39273 10.9091 8 10.9091C9.60727 10.9091 10.9091 9.60727 10.9091 8C10.9091 6.39273 9.60727 5.09091 8 5.09091ZM14.5018 7.27273C14.1673 4.24 11.76 1.83273 8.72727 1.49818V0H7.27273V1.49818C4.24 1.83273 1.83273 4.24 1.49818 7.27273H0V8.72727H1.49818C1.83273 11.76 4.24 14.1673 7.27273 14.5018V16H8.72727V14.5018C11.76 14.1673 14.1673 11.76 14.5018 8.72727H16V7.27273H14.5018ZM8 13.0909C5.18909 13.0909 2.90909 10.8109 2.90909 8C2.90909 5.18909 5.18909 2.90909 8 2.90909C10.8109 2.90909 13.0909 5.18909 13.0909 8C13.0909 10.8109 10.8109 13.0909 8 13.0909Z" fill="currentColor"/>
                </svg>    
                <div class="font-13 font-500 flex justify-center align-center">Localizar meu endereço através do mapa</div>         
            </div>`
        }
        wrapper.innerHTML = `        
        <div class="wrapper-content">
            <div class="u-flex-between header">
                <div class="font-500 color-blue">Cadastrar Endereço</div>
                <div>
                    <svg class="close-button-endereco" width="16" height="16" viewBox="0 0 16 16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M3.72001 3.72003C3.86063 3.57958 4.05126 3.50069 4.25001 3.50069C4.44876 3.50069 4.63938 3.57958 4.78001 3.72003L8.00001 6.94003L11.22 3.72003C11.2887 3.64634 11.3715 3.58724 11.4635 3.54625C11.5555 3.50526 11.6548 3.48322 11.7555 3.48144C11.8562 3.47966 11.9562 3.49819 12.0496 3.53591C12.143 3.57363 12.2278 3.62977 12.299 3.70099C12.3703 3.77221 12.4264 3.85705 12.4641 3.95043C12.5018 4.04382 12.5204 4.14385 12.5186 4.24455C12.5168 4.34526 12.4948 4.44457 12.4538 4.53657C12.4128 4.62857 12.3537 4.71137 12.28 4.78003L9.06001 8.00003L12.28 11.22C12.3537 11.2887 12.4128 11.3715 12.4538 11.4635C12.4948 11.5555 12.5168 11.6548 12.5186 11.7555C12.5204 11.8562 12.5018 11.9562 12.4641 12.0496C12.4264 12.143 12.3703 12.2278 12.299 12.299C12.2278 12.3703 12.143 12.4264 12.0496 12.4641C11.9562 12.5018 11.8562 12.5204 11.7555 12.5186C11.6548 12.5168 11.5555 12.4948 11.4635 12.4538C11.3715 12.4128 11.2887 12.3537 11.22 12.28L8.00001 9.06003L4.78001 12.28C4.63783 12.4125 4.44978 12.4846 4.25548 12.4812C4.06118 12.4777 3.8758 12.399 3.73838 12.2616C3.60097 12.1242 3.52226 11.9388 3.51883 11.7445C3.5154 11.5502 3.58753 11.3622 3.72001 11.22L6.94001 8.00003L3.72001 4.78003C3.57956 4.63941 3.50067 4.44878 3.50067 4.25003C3.50067 4.05128 3.57956 3.86066 3.72001 3.72003Z"
                            fill="#24292E" />
                    </svg>
                </div>
            </div>
            <div class="map-area">
                <div id="map"></div>
                <div class="flex flex-column u-relative">
                    <div class="input-wrapper">
                        <input type="text" id="buscar-endereco" placeholder="Digite aqui seu endereço (Ex: Rua dos sabiás, 120)" spellcheck="false">
                        <input type="checkbox" id="check-endereco" class="oculto">
                        <div class="btn-pesquisa">
                            <svg class="svg-search" width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M11.5 7.00002C11.5 7.59096 11.3836 8.17613 11.1574 8.72209C10.9313 9.26806 10.5998 9.76413 10.182 10.182C9.7641 10.5998 9.26803 10.9313 8.72206 11.1575C8.1761 11.3836 7.59094 11.5 6.99999 11.5C6.40904 11.5 5.82388 11.3836 5.27791 11.1575C4.73195 10.9313 4.23587 10.5998 3.81801 10.182C3.40014 9.76413 3.06868 9.26806 2.84253 8.72209C2.61638 8.17613 2.49999 7.59096 2.49999 7.00002C2.49999 5.80654 2.97409 4.66195 3.81801 3.81804C4.66192 2.97412 5.80651 2.50002 6.99999 2.50002C8.19346 2.50002 9.33805 2.97412 10.182 3.81804C11.0259 4.66195 11.5 5.80654 11.5 7.00002ZM10.68 11.74C9.47437 12.676 7.95736 13.1173 6.43779 12.9741C4.91822 12.831 3.51033 12.1141 2.50074 10.9694C1.49114 9.82473 0.955743 8.33831 1.00352 6.81277C1.05131 5.28722 1.67869 3.83722 2.75794 2.75797C3.8372 1.67872 5.28719 1.05134 6.81274 1.00355C8.33829 0.955771 9.8247 1.49117 10.9694 2.50077C12.1141 3.51036 12.831 4.91825 12.9741 6.43782C13.1173 7.95738 12.676 9.47439 11.74 10.68L14.78 13.72C14.8537 13.7887 14.9128 13.8715 14.9538 13.9635C14.9948 14.0555 15.0168 14.1548 15.0186 14.2555C15.0204 14.3562 15.0018 14.4562 14.9641 14.5496C14.9264 14.643 14.8702 14.7278 14.799 14.799C14.7278 14.8703 14.643 14.9264 14.5496 14.9641C14.4562 15.0018 14.3562 15.0204 14.2555 15.0186C14.1548 15.0168 14.0554 14.9948 13.9635 14.9538C13.8715 14.9128 13.7887 14.8537 13.72 14.78L10.68 11.74Z"
                                    fill="currentColor" />
                            </svg>
                            <div class="showbox">
                                <div class="loader">
                                    <svg class="circular" viewBox="25 25 50 50">
                                        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2"
                                            stroke-miterlimit="10"></circle>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="results"></div>
                    <div class="flex flex-column geolocation-map">
                        <div class="flex u-center">
                            <svg width="127" height="118" viewBox="0 0 127 118" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M106.44 91.9323C106.231 92.2406 105.679 92.6072 105.464 92.9106L105.693 92.2137L105.615 92.0526L105.127 91.0743L92.6982 65.9834L92.6934 65.9786L71.624 23.4641V23.4592L71.1406 22.4861V22.4812L60.7134 1.43916L60.2205 0.441589C60.5912 0.451372 60.9622 0.466041 61.3333 0.4856L61.8313 1.48806L72.2295 22.4812L72.2339 22.4861L72.7176 23.4592V23.4641L93.2497 64.8978V64.9026L93.733 65.8757V65.8805L106.162 90.9522L106.328 91.2896L106.44 91.9323Z" fill="#3F3D56" /> <path d="M105.054 23.464H12.0381C12.2872 23.1364 12.5408 22.8088 12.8045 22.486H104.287C104.551 22.8088 104.804 23.1364 105.054 23.464Z" fill="#3F3D56" /> <path d="M116.838 64.9026C116.809 65.2304 116.774 65.5579 116.731 65.8805H92.9029V64.9026H116.838Z" fill="#3F3D56" /> <path d="M105.919 91.0739H15.0893V92.0518H105.919V91.0739Z" fill="#3F3D56" /> <path d="M105.84 91.9323H105.952V91.7712C105.918 91.8272 105.88 91.8811 105.84 91.9323ZM105.088 23.3441C104.839 23.0165 104.585 22.6888 104.321 22.3661C99.1362 15.8491 92.6224 10.5155 85.2152 6.7216C77.8079 2.92767 69.6777 0.760746 61.3675 0.365581C60.9968 0.346006 60.6258 0.331343 60.2547 0.321581C59.6981 0.306908 59.1415 0.297127 58.5801 0.297127C50.5066 0.292809 42.5196 1.96536 35.1241 5.20917C27.7284 8.45303 21.0844 13.1977 15.6116 19.1435C15.2748 19.5005 14.9525 19.8624 14.6353 20.2242C14.0153 20.9235 13.4165 21.6375 12.8387 22.3661C12.5751 22.6888 12.3215 23.0165 12.0724 23.3441C3.82259 34.1177 -0.432724 47.4286 0.0347997 60.9986C0.502327 74.5686 5.66361 87.5538 14.6353 97.732C14.9525 98.0941 15.2748 98.4559 15.6116 98.8128C21.5112 105.213 28.7608 110.215 36.8329 113.455C44.9054 116.695 53.5969 118.091 62.276 117.543C70.9547 116.994 79.4026 114.515 87.0042 110.284C94.6062 106.054 101.17 100.178 106.22 93.0865C106.435 92.7834 106.65 92.4803 106.86 92.172C112.274 84.315 115.675 75.2449 116.765 65.7606C116.809 65.438 116.843 65.1102 116.872 64.7827C117.062 62.8756 117.158 60.9407 117.16 58.9782C117.175 46.0904 112.93 33.5606 105.088 23.3441ZM115.784 65.7606C114.721 74.8643 111.49 83.5787 106.362 91.1697C106.23 91.37 106.094 91.5706 105.952 91.7712C105.918 91.8272 105.88 91.8811 105.84 91.9323C105.806 91.9861 105.766 92.04 105.727 92.0938C100.748 99.2214 94.2219 105.127 86.639 109.368C79.0562 113.609 70.6135 116.076 61.9436 116.583C53.2734 117.09 44.6017 115.625 36.5775 112.297C28.5535 108.968 21.3857 103.864 15.6116 97.3655C15.2748 96.9938 14.9478 96.6221 14.6353 96.2404C6.05116 86.1097 1.22887 73.3167 0.985973 60.0306C0.743079 46.7446 5.09454 33.7831 13.3026 23.3441C13.5614 23.0164 13.8201 22.6888 14.0885 22.3661C14.2644 22.146 14.4448 21.9308 14.6353 21.7157C14.9478 21.3342 15.2748 20.9626 15.6116 20.5909C21.0044 14.5125 27.6222 9.64826 35.0287 6.31878C42.4353 2.98931 50.4621 1.27032 58.5801 1.27512C59.3075 1.27512 60.0301 1.28978 60.7476 1.31912C61.1234 1.3289 61.4945 1.34847 61.8656 1.36803C69.8102 1.82297 77.5742 3.924 84.667 7.5383C91.7595 11.1526 98.0267 16.2016 103.072 22.366C103.34 22.6888 103.599 23.0164 103.858 23.3441C113.069 35.0776 117.384 49.9302 115.896 64.7827C115.862 65.1102 115.828 65.438 115.784 65.7606H115.784ZM105.84 91.9323H105.952V91.7712C105.918 91.8272 105.88 91.8811 105.84 91.9323Z" fill="#CCCCCC" /> <path d="M108.198 28.3693C98.0738 26.3373 87.9179 24.4939 77.6382 23.3658C67.8913 22.2174 58.0622 21.9327 48.2655 22.515C39.4179 23.1128 30.4942 24.5147 22.1824 27.7105C15.7775 30.1731 8.95019 33.899 5.49049 40.1126C2.15551 46.1026 3.45626 53.0096 7.08763 58.5361C11.4569 65.1854 18.2703 69.742 25.3539 73.0722C33.4192 76.8641 42.0458 79.3218 50.6833 81.4122C55.0643 82.4724 59.4688 83.4308 63.8736 84.3844C64.7925 84.5831 65.1852 83.1693 64.2627 82.9695C55.3801 81.0468 46.4717 79.1179 37.8096 76.3346C29.7934 73.7588 21.5902 70.4593 15.0259 65.0512C9.71528 60.6756 4.66602 54.2848 4.97947 47.0186C5.29546 39.6933 11.4308 34.5789 17.4442 31.4308C24.9594 27.4966 33.4977 25.5803 41.864 24.5787C51.4438 23.5094 61.105 23.3778 70.7103 24.1857C83.5476 25.1642 96.1949 27.434 108.794 29.9763" fill="black" /> <path d="M118.015 31.9463C115.91 30.4608 113.532 29.4054 111.02 28.8402C108.507 28.275 105.907 28.2112 103.37 28.6523C100.832 29.0934 98.4066 30.0309 96.2307 31.4112C94.0551 32.7915 92.1718 34.5875 90.689 36.6968C84.4524 45.5675 78.1948 68.829 82.6122 82.3046C95.7878 68.3633 116.03 66.9145 122.758 59.3197C129.946 51.2042 126.871 38.1933 118.015 31.9463Z" fill="#6C63FF" /> <path d="M106.457 52.0335C109.989 52.0335 112.853 49.165 112.853 45.6265C112.853 42.088 109.989 39.2195 106.457 39.2195C102.924 39.2195 100.061 42.088 100.061 45.6265C100.061 49.165 102.924 52.0335 106.457 52.0335Z" fill="white" /> <path d="M77.2053 89.2821C79.5189 89.2821 81.3945 87.4033 81.3945 85.0857C81.3945 82.7681 79.5189 80.8893 77.2053 80.8893C74.8917 80.8893 73.0162 82.7681 73.0162 85.0857C73.0162 87.4033 74.8917 89.2821 77.2053 89.2821Z" fill="#6C63FF" /> <path opacity="0.2" d="M113.299 44.1482C113.723 44.875 114 45.6778 114.113 46.5115C114.227 47.3453 114.176 48.193 113.962 49.0069C113.749 49.8203 113.378 50.584 112.869 51.254C112.361 51.924 111.727 52.4871 111.001 52.9116C110.276 53.3356 109.474 53.6129 108.642 53.7265C107.81 53.8404 106.963 53.7892 106.151 53.5753C105.339 53.3614 104.576 52.9897 103.907 52.4805C103.238 51.9716 102.676 51.3359 102.253 50.6091C103.395 51.6124 104.855 52.1759 106.374 52.1991C107.892 52.222 109.369 51.7028 110.541 50.7345C111.712 49.7661 112.501 48.4117 112.767 46.9138C113.032 45.416 112.757 43.8724 111.99 42.5593C112.509 43.0147 112.952 43.5512 113.299 44.1482Z" fill="#231F20" /> <path opacity="0.2" d="M122.77 59.3499C116.042 66.9447 95.8 68.3935 82.6244 82.3349C82.2128 81.0597 81.8962 79.7562 81.6772 78.4342C94.8465 65.7603 113.961 64.1588 120.462 56.8207C126.28 50.2529 125.374 40.4795 120.123 33.6791C127.324 40.3656 129.357 51.913 122.77 59.3499Z" fill="#231F20" /></svg>
                        </div>
                        ${geolocationHTML}                        
                    </div>
                </div>
                <div class="confirmar-endereco flex gap-8 flex-column">
                    <div class="flex gap-8">
                        <div class="flex-1">
                            <div id="endereco-rua"></div>
                            <div id="endereco-subtitulo" class="font-12 font-500 font-seccondary"></div>
                        </div>
                        <div class="input-wrapper numero">
                            <input type="number" id="endereco-numero" name="numero" required="true" autocomplete="off">
                            <label>Número</label>
                        </div>
                    </div>
                    <button id="confirmar-button" class="btn btn-azul">Continuar</button>
                    <div class="font-10 font-500 font-seccondary text-center">
                        Você pode editar as informações do endereço na próxima etapa
                    </div>
                </div>
            </div>
        </div>
    `

        const closeButton = select('.close-button-endereco', wrapper)
        closeButton.addEventListener('click', () => {
            wrapper.remove()
        })


        document.body.appendChild(wrapper)
    }
}

function formataEnderecoGeocoder(result) {
    //formata o endereço recebido pela api geocoder, exbindo apenas o nome da rua, numero, bairro, e cidade    
    const enderecoComponents = result.address_components
    const findComponent = (component, property) => {
        const item = enderecoComponents.find(componente => componente.types.includes(component))
        return item ? item[property] : null
    }

    const shortAddress = [
        findComponent('route', 'long_name'),
        findComponent('street_number', 'long_name'),
        findComponent('sublocality_level_1', 'long_name')
    ].filter(item => item).join(', ')

    const endereco = {
        rua: findComponent('route', 'long_name'),
        numero: findComponent('street_number', 'long_name'),
        bairro: findComponent('sublocality_level_1', 'long_name'),
        cidade: findComponent('administrative_area_level_2', 'long_name'),
        estado: findComponent('administrative_area_level_1', 'short_name'),
        cep: findComponent('postal_code', 'long_name'),
        enderecoFormatado: result.formatted_address,
        shortAddress: shortAddress,
        coordenadas: {
            lat: result.geometry.location.lat(),
            lng: result.geometry.location.lng()
        },
        enderecoComponents: enderecoComponents
    }

    return endereco
}

export function cadastrarNovoEndereco(config = {}) {
    if (estabelecimento.tipoEntrega != 'bairro') {
        try {
            console.log('busca localizacao')
            buscaLocalizacaoUsuario()
        } catch (e) {
            Sentry.captureException(e)
            console.error(e)
            novoEndereco()
        }
    } else if (estabelecimento.tipoEntrega === 'bairro') {
        novoEndereco("", "", config.obrigatorioCPF)
    }
}